// ak — checkin/quickCheck/stepTracker blocks translated.
export const ak = {
  "common": {
    "loading": "Ɛreba...",
    "save": "Kora so",
    "cancel": "Twa mu",
    "delete": "Popa ne nyinaa",
    "edit": "Sesa no",
    "close": "To mu",
    "confirm": "Si so pi",
    "back": "San kɔ akyi",
    "next": "Deɛ ɛdi hɔ",
    "submit": "Mane",
    "search": "Hwehwɛ",
    "select": "Yi",
    "or": "Anaasɛ",
    "and": "na",
    "note": "Hyɛ no nso",
    "viewAll": "Hwɛ ne nyinaa",
    "learnMore": "Sua pii ka ho",
    "getStarted": "Fi ase",
    "continue": "Toa so",
    "saving": "Ɛrekora so…"
  },
  "nav": {
    "dashboard": "Fie",
    "nutrition": "Aduane",
    "family": "Abusua",
    "care": "Dwumadie",
    "careShort": "Dwumadie",
    "checkIn": "Hwɛ wo ho",
    "insights": "Nhunu",
    "trends": "Nhwehwɛmu",
    "habits": "Suban",
    "medications": "Aduro",
    "expertSupport": "Animfefoɔ Mmoa",
    "profile": "Me Ho Asɛm",
    "healthHub": "Apɔmuden Bea",
    "support": "Mmoa",
    "wellness": "Apɔmuden",
    "education": "Nkyerɛkyerɛ",
    "community": "Mpɔtam",
    "preventiveHealth": "Ahobammɔ",
    "womensHealth": "Mmaa Apɔmuden",
    "reminders": "Nkaebɔ",
    "meals": "Aduane",
    "orders": "Nneɛma a woatɔ",
    "subscription": "Sesei Dwumadie",
    "logout": "Pue mu"
  },

  "navShort": {
    "dashboard": "Fie",
    "nutrition": "Aduane",
    "family": "Abusua",
    "care": "Nnwuma",
    "support": "Mmoa",
    "profile": "Wo Ho"
  },
  "auth": {
    "login": "Wura mu",
    "register": "Gye akontaabu foforɔ",
    "logout": "Pue mu",
    "email": "Email",
    "password": "Password",
    "name": "Din Nyinaa",
    "forgotPassword": "Woatwerɛmffi wo password?",
    "noAccount": "Wo nni akontaabu anaa?",
    "haveAccount": "Wo wɔ akontaabu dedaw?",
    "signInHere": "Wura mu wɔ ha",
    "signUpHere": "Gye akontaabu wɔ ha",
    "welcomeBack": "Akwaaba bio!",
    "getStarted": "Ma yɛmfi ase",
    "biometricLogin": "Wura mu ne nsa-hiamuo",
    "biometricHelper": "Fa wo nsa-hiamuo anaasɛ Face ID",
    "vendorLogin": "Adwumayɛfoɔ Wura-mu",
    "createOne": "Gye foforɔ",
    "tagline": "Di wo apɔmuden anim — hwehwɛ wo ho mu da biara.",
    "takes30s": "Ɛnkyɛ koraa",
    "emailPlaceholder": "wo@nhwɛsoɔ.com",
    "passwordPlaceholder": "Hyɛ wo password",
    "checking": "Ɛrehwehwɛ mu…",
    "continue": "Toa so",
    "secureMessage": "Yɛakora wo ho asɛm so yie — obiara nhu",
    "biometricSoon": "Nsa-hiamuo — Ɛreba nkyɛree",
    "sessionExpired": "Wo berɛ aso. Yɛsrɛ wo san wura mu bio."
  },
  "quickCheck": {
    "header": {
      "title": "Tebea bɛn mu na wowɔ ɛnnɛ?",
      "subtitle": "Nhwehwɛmu ntɛm — eyi nnye sika dɔnhwere mma korɔ"
    },
    "section1": {
      "title": "Dɛn na worehu ɛnnɛ?",
      "hint": "(Yi nea ɛfa wo ho nyinaa)"
    },
    "environment": {
      "title": "Baabi a wowɔ ɛnnɛ",
      "hint": "Boa yɛn ma yɛnte baabi a wowɔ no ase"
    },
    "basicChecks": {
      "title": "Nhwehwɛmu nketewa a ɛho hia",
      "hint": "Wobɛtumi agyae nanso ɛboa"
    },
    "validation": {
      "pickOne": "Yɛsrɛ wo bua asɛmmisa baako pɛ"
    },
    "submit": {
      "cta": "Nya M’akwahosan Nhunumu",
      "saving": "Yɛrekora so...",
      "analyzing": "Yɛrehwɛ wo akwahosan ho nneɛma...",
      "savedToast": "✅ Nhwehwɛmu no akora! Yɛrehwɛ wo akwahosan ho nneɛma..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Anammɔn Twerefoɔ",
      "subtitle": "Nokorɛdie adwumayɛ ho nhwehwɛmu",
      "backToDashboard": "San kɔ wo mfonini mu"
    },
    "today": {
      "title": "Ɛnnɛ anammɔn",
      "goalProgress": "Anammɔn {{current}} / {{goal}}",
      "goalReached": "Woaduru wo botaeɛ ho — adwuma pa!",
      "keepGoing": "Toa so — wowɔ kwan pa so."
    },
    "streak": {
      "label": "Nkɔsoɔ mprempren",
      "days": "da {{count}}",
      "daysPlural": "nna {{count}}"
    },
    "badges": {
      "title": "Abasobɔdeɛ",
      "empty": "Wobenya abasobɔdeɛ berɛ a woreyɛ no dabiabia no."
    },
    "reminders": {
      "title": "Kanyan nneyɛeɛ",
      "hint": "Nkaebɔ nketewa sɛ wo bɛnante kakra berɛ a woatena ase akyɛ.",
      "enabled": "Ɛyɛ adwuma",
      "disabled": "Ɛnyɛ adwuma"
    },
    "insights": {
      "weeklyAverage": "Nawotwe mu mfinimfini",
      "weeklyGoal": "Nawotwe botaeɛ"
    },
    "actions": {
      "connect": "Fa anammɔn mfidie bi bata ho",
      "manualLog": "Twere anammɔn no wo nsa",
      "changeGoal": "Sesa dabiabia botaeɛ"
    }
  },
  "checkin": {
    "header": {
      "title": "Dabiabia Akwahosan Nhwehwɛmu",
      "subtitle": "Ennye kyen sika dɔnhwere mma korɔ",
      "restDayLink": "Ɛnnɛ me ho mmu mmaa me"
    },
    "snapshot": {
      "title": "Wo dwumadie mfonini, yɛayɛ no foforɔ",
      "healthScore": "Akwahosan nkontabuo",
      "todayTasks": "Ɛnnɛ nnwuma",
      "dayStreak": "nkɔsoɔ nna"
    },
    "resume": {
      "banner": "Yɛatoa so firi baabi a wogyaeɛ no",
      "startFresh": "Firi aseɛ foforɔ",
      "dismiss": "Yi firi hɔ"
    },
    "progress": {
      "allSet": "Biribiara akɔ yie",
      "step": "Anammɔn {{current}} wɔ {{total}} mu",
      "ariaLabel": "Dabiabia nhwehwɛmu nkɔsoɔ: {{done}} wɔ {{total}} afã afã a awie"
    },
    "insights": {
      "title": "Wo Akwahosan Ho Nhunumu",
      "subtitle": "Yɛayɛ no nti wo nko ara ɛnnɛ",
      "insightForYou": "Nhunumu ma wo",
      "simpleActions": "Nneyɛeɛ nketewa a wubetumi ayɛ",
      "whenToSeekHelp": "Berɛ a ɛsɛ sɛ wohwehwɛ mmoa",
      "nhsAdvice": "Sɛ wosusu ho a, frɛ NHS 111 anaa wo dɔkota",
      "backToDashboard": "San kɔ Wo Mfonini mu",
      "newCheckIn": "Nhwehwɛmu Foforɔ",
      "disclaimer": "HealthLoop de akwankyerɛ na ɛma, ɛnyɛ yareɛ ho nkyerɛkyerɛmu."
    },
    "restDay": {
      "title": "Ahomegyeɛ nso ka akwahosan ho.",
      "body": "Yɛbɛwɔ ha nnora, berɛ a woasiesie wo ho.",
      "streakNote": "Wo nkɔsoɔ nna no nsesaeɛ — ɛno nso regye n’ahome.",
      "backToDashboard": "San kɔ wo mfonini mu",
      "changedMind": "Nokorɛm no, mepɛ sɛ meyɛ nhwehwɛmu no mpo."
    },
    "feelings": {
      "title": "Tebea bɛn mu na wowɔ ɛnnɛ?",
      "hint": "Yi nea ɛfa wo ho nyinaa",
      "tired": "Mabrɛ",
      "headache": "Ti yareɛ",
      "stressed": "Adwene mu nnaadaa",
      "pain": "Apɔmuden yaw anaa nipadua mu yaw",
      "okay": "Me ho yɛ ɛnnɛ"
    },
    "basics": {
      "title": "Wo nneyɛeɛ titiriw",
      "sleepQ": "Wodaa yie anadwo no?",
      "waterQ": "Woanom nsuo a ɛdɔɔso ɛnnɛ?",
      "foodQ": "Woadidi yie ɛnnɛ?",
      "activityQ": "Adwumaden bɛn na woyɛɛ no ɛnnɛ?",
      "yes": "Aane",
      "notReally": "Anka ɛnyɛ saa pii",
      "notYet": "Ɛnya mmaeɛ",
      "notActive": "Manyɛ adwuma pii",
      "lightActivity": "Adwuma ketewa",
      "active": "Meyɛɛ adwuma"
    },
    "mind": {
      "title": "Adwene ne Ahooden",
      "stressQ": "Adwene mu nnaadaa no te sɛn ɛnnɛ?",
      "moodQ": "Wo nteaseɛ te sɛn ɛnnɛ?",
      "energyQ": "Wo nipadua mu ahooden te sɛn ɛnnɛ?",
      "low": "Ɛba fam",
      "moderate": "Mfinimfini",
      "high": "Ɛkɔ soro",
      "neutral": "Ɛda mu",
      "good": "Eye",
      "okay": "Ɛyɛ"
    },
    "day": {
      "title": "Wo da no",
      "routineQ": "Wodi nneɛma a wotaa yɛ no so ɛnnɛ?",
      "yes": "Aane",
      "no": "Dabi"
    },
    "environment": {
      "title": "Baabi a wowɔ ɛnnɛ",
      "describeQ": "Sɛn na wobɛkyerɛkyerɛ baabi a wowɔ no mu?",
      "comfortable": "😊 Ɛyɛ fɛ",
      "slightlyUncomfortable": "😐 Ɛnyɛ dɛ pii",
      "challenging": "😓 Ɛyɛ den",
      "affectedQ": "Baabi a wowɔ no nyaa wo nteaseɛ so tumi?",
      "yes": "Aane",
      "no": "Dabi",
      "exposureLabel": "Nneɛma a ɛkaa wo (yi nea ɛfa wo ho nyinaa)",
      "heat": "🌡️ Ahuhuro",
      "cold": "❄️ Awɔ",
      "noise": "🔊 Dedeyɛ",
      "dustSmoke": "💨 Mfutuma anaa wisie",
      "crowded": "👥 Nnipadɔm",
      "none": "✅ Biara nni mu"
    },
    "submit": {
      "analyzing": "Yɛrehwɛ wo akwahosan ho nneɛma...",
      "cta": "Hwɛ M’akwahosan Nhunumu"
    },
    "toast": {
      "savedFull": "Yɛakora nhwehwɛmu no so! Wo mfonini no ayɛ foforɔ.",
      "savedShort": "Nhwehwɛmu no akora."
    }
  },
  "onboarding": {
    "welcome": "Akwaaba",
    "completeSetup": "Wie nhyehyɛeɛ no",
    "stepProgress": "Fa a ɛtɔ so {{step}} wɔ {{total}} mu",
    "percentComplete": "{{percent}}% awie",
    "welcomeToast": "Akwaaba kɔ HealthLoop! Yɛawie wo ho asɛm no yɛ.",
    "errorAgeRange": "Yɛsrɛ wo yi mfeɛ a woadi",
    "errorCountry": "Yɛsrɛ wo yi wo kurom",
    "errorGoal": "Yɛsrɛ wo yi botaeɛ titiriw a wowɔ",
    "errorCuisine": "Yɛsrɛ wo yi aduane a wopɛ koraa baako",
    "errorGeneric": "Antumi amwie nhyehyɛeɛ no. Yɛsrɛ wo bɔ mmɔden bio.",
    "step1Title": "Akwaaba kɔ HealthLoop! 👋",
    "step1Subtitle": "Ma yɛnhyehyɛ wo apɔmuden kwan yie",
    "ageRangeLabel": "Mfeɛ sɛn na woadi?",
    "genderLabel": "Barima anaasɛ Baa (Wopɛ a)",
    "gender_male": "Barima",
    "gender_female": "Baa",
    "gender_non-binary": "Emu biara",
    "gender_prefer_not_to_say": "Mempɛ sɛ meka",
    "step2Title": "Ɛhe na wowɔ? 🌍",
    "step2Subtitle": "Eyi bɛboa ama yɛakyerɛ wo aduane a ɛfata wo",
    "countryLabel": "Yi wo kurom",
    "country_uk": "United Kingdom",
    "country_nigeria": "Nigeria",
    "country_ghana": "Ghana",
    "country_kenya": "Kenya",
    "country_south_africa": "South Africa",
    "country_usa": "United States",
    "country_canada": "Canada",
    "country_india": "India",
    "country_jamaica": "Jamaica",
    "country_other": "Baabi foforɔ",
    "step3Title": "Dɛn ne wo botaeɛ titiriw? 🎯",
    "step3Subtitle": "Yi dɛn na wopɛ sɛ woyɛ ma wo apɔmuden",
    "additionalGoals": "Botaeɛ foforɔ biara? (Wopɛ a)",
    "goal_weight_loss": "Te wo mu",
    "goalDesc_weight_loss": "Te wo mu wɔ kwan pa so",
    "goal_weight_maintenance": "Kura wo mu",
    "goalDesc_weight_maintenance": "Kura wo mu sɛnea wowɔ sesei",
    "goal_muscle_gain": "Nya ntini",
    "goalDesc_muscle_gain": "Nya ahoɔden ne ntini",
    "goal_general_wellness": "Apɔmuden Nyinaa",
    "goalDesc_general_wellness": "Ma wo nkwa mu nyinaa nyɛ yie",
    "goal_better_sleep": "Nna pa",
    "goalDesc_better_sleep": "Ma wo nna mu nyɛ yie",
    "goal_reduce_stress": "Te dadwen so",
    "goalDesc_reduce_stress": "Hwɛ wo dadwen so yie",
    "goal_increase_energy": "Ahoɔden Pii",
    "goalDesc_increase_energy": "Nya ahoɔden pii da biara",
    "step4Title": "Aduane a wopɛ 🍽️",
    "step4Subtitle": "Yi aduane a wopɛ ne nea wo nni",
    "cuisineLabel": "Aduane a m’ani gye ho",
    "cuisineHint": "Yi koraa baako (wobɛtumi ayi pii)",
    "dietaryLabel": "Aduane a me nni (Wopɛ a)",
    "diet_vegetarian": "Aduane a ɛnyɛ nam",
    "diet_vegan": "Nhahan-nkoaa",
    "diet_halal": "Halal",
    "diet_kosher": "Kosher",
    "diet_gluten_free": "Gluten-Free",
    "diet_dairy_free": "Miliki-Free",
    "diet_pescatarian": "Nam-nkoaa (Apataa)",
    "step5Title": "Yadeɛ a wowɔ 🏥",
    "step5Subtitle": "Wopɛ a — eyi bɛboa ma yɛama wo afutuo pa",
    "conditionsLabel": "Wo wɔ saa yadeɛ yi bi?",
    "conditionsHint": "Saa asɛm yi yɛ kokoam deɛ a ɛbɛboa wo",
    "condition_diabetes": "Asikyire yadeɛ",
    "condition_hypertension": "Mogya mborosoɔ",
    "condition_heart_disease": "Akoma yadeɛ",
    "condition_thyroid": "Thyroid",
    "condition_celiac": "Celiac",
    "condition_ibs": "IBS",
    "condition_none": "Ebiara nni mu",
    "privacyTitle": "Wo ho asɛm kora so yie",
    "privacyBody": "Wo ho asɛm biara yɛasiesie no yie. Yɛde bɛboa wo nkoaa wɔ aduane ne apɔmuden ho afutuo mu. Yɛmfa nkyerɛ obiara gye sɛ woapene so.",
    "trackMedication": "Mepɛ sɛ mehwehwɛ m’aduro so",
    "specialistInterest": "Mepɛ sɛ me ne oduruyɛfoɔ titiriw ka asɛm",
    "welcomeTitle": "Akwaaba ba HealthLoop! 👋",
    "welcomeSubtitle": "Ma yɛnhyehyɛ wo wellness ne nkwa mu nyansa a AI boa ma ɛyɛ mmerɛ wɔ akwan kakra bi mu",
    "stepLabel": "Anamɔn {{current}} wɔ {{total}} mu",
    "skipForNow": "Gyae mu seesei",
    "skipToast": "Wubetumi awie hyehyɛe yi bere biara wɔ wo profile mu",
    "back": "San kɔ akyi",
    "next": "Toa so",
    "completing": "Ɛreyɛ...",
    "complete": "Wie Hyehyɛe no",
    "successToast": "Akwaaba ba HealthLoop! Wo profile no asiesie yiye ama wo 🎉",
    "failureToast": "Anantumi amwie hyehyɛe no",
    "validation": {
      "basicInfo": "Yɛsrɛ wo, hyɛ nsɛm atitiriw no nyinaa mu",
      "pickGoal": "Yɛsrɛ wo, paw botae biako anaa nea ɛboro saa",
      "pickPrimary": "Yɛsrɛ wo, paw wo botae titiriw",
      "pickRegion": "Yɛsrɛ wo, paw amammere mmeaɛ a wofiri na ama yɛatumi akyerɛ wo nnuane a ɛfata wo",
      "pickFocus": "Yɛsrɛ wo, paw nea wopɛ sɛ wode w’adwene si so kɛse wɔ wellness mu"
    },
    "step1": {
      "title": "Wo Wellness Profile",
      "description": "Boa yɛn ma yɛnhyehyɛ wo nkwa mu nyansa a AI boa ma ɛyɛ mmerɛ",
      "age": "Wo mfe *",
      "agePlaceholder": "e.g., 30",
      "height": "Wo tenten (cm) *",
      "heightPlaceholder": "e.g., 170",
      "weight": "Wo mu duru (kg) *",
      "weightPlaceholder": "e.g., 70"
    },
    "step2": {
      "title": "Wo Wellness Botae",
      "description": "Paw nea ɛfa wo ho nyinaa, na paw wo botae titiriw",
      "primaryLabel": "Paw Wo Botae Titiriw *",
      "primaryBadge": "Titiriw"
    },
    "step3": {
      "title": "🌍 Amammere & Aduane a Wopɛ",
      "description": "Boa yɛn ma yɛnkyerɛ wo nnuane a ɛfata wo",
      "regionLabel": "Amammere Mmeaɛ *",
      "regionHint": "Paw wo mmeaɛ anaa amammere na yɛatumi akyerɛ wo nnuane a ɛfata wo",
      "countryLabel": "Ɔman (Sɛ wopɛ)",
      "countryPlaceholder": "e.g., Nigeria, Kenya, Jamaica",
      "countryHint": "Sɛnea ɛbɛyɛ a yɛbɛtumi akyerɛ wo nnuane pa ara a ɛfata wo",
      "foodPrefLabel": "Aduane ahorow a wopɛ"
    },
    "step4": {
      "title": "Wellness mu Titiriw",
      "description": "Paw baabi a wopɛ sɛ wode w’adwene si so kɛse"
    },
    "step5": {
      "title": "Nea Wopɛ",
      "description": "Siesie HealthLoop snea wopɛ",
      "trackMeds": "Hwɛ wo nnuru so",
      "trackMedsHint": "Ma yɛnkae wo na boa wo ma nhwɛ nnuru a wonom so da biara",
      "specialist": "Me ho nni animdefo mmoa",
      "specialistHint": "Nya kwan ne wellness animdefo, nnuane ho animdefo, ne adwene mu akwahosan ho animdefo nkitaho",
      "confidentialTitle": "Mmoa a ɛyɛ kokoa:",
      "confidentialBody": "Wo nsɛm nyinaa yɛ kokoa na yɛde bɛdi dwuma kɛkɛ de ama wo wellness ho nyansa."
    },
    "step6": {
      "title": "Aduane ho Nsiesie",
      "description": "Boa yɛn ma yɛnkyerɛ wo nnuane a ɛne wo dɛ ne wo nnuane ho ahiade hyia",
      "cuisinesLabel": "Nnuane ahorow a wopɛ (Sɛ wopɛ)",
      "cuisinesHint": "Paw nnuane ahorow a w’ani gye ho kɛse",
      "dietaryLabel": "Nnuane a wonni (Sɛ wopɛ)",
      "dietaryHint": "Paw nea ɛfa wo ho",
      "allergiesLabel": "Aduane a ɛnyɛ mma wo (Sɛ wopɛ)",
      "allergiesHint": "Paw aduane biara a wunni",
      "personalisedTitle": "Nnuane a yɛasiesie ama wo:",
      "personalisedBody": "Yɛde nsɛm yi bɛkyerɛ wo nnuane a ɛne wo dɛ ne w’ahiade hyia. Wubetumi asakyera eyi bere biara wɔ Settings mu."
    },
    "healthGoals": {
      "better_sleep": "Nna Pa",
      "reduce_stress": "Tew Dadwen So",
      "increase_energy": "Nya Ahooden",
      "weight_management": "Mu Duru So Hwɛ",
      "improve_fitness": "Apɔmuden a Ɛyɛ",
      "better_nutrition": "Nnuane Pa",
      "mental_wellness": "Adwene mu Yiedie",
      "chronic_condition": "Hwɛ Wo Ho So"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Adwene mu Akwahosan",
        "description": "Fa w'adwene si suban, dadwen, ne nkate so"
      },
      "physical_fitness": {
        "label": "Apɔmuden Dwumadi",
        "description": "Fa w'adwene si nante, ahooden, ne nneɛma a ɛkanyan honam so"
      },
      "nutrition": {
        "label": "Nnuane Pa",
        "description": "Fa w'adwene si nnuane ne adidie pa so"
      },
      "sleep": {
        "label": "Nna Pa",
        "description": "Fa w'adwene si ahomegye ne nna pa so"
      },
      "stress_management": {
        "label": "Dadwen So Hwɛ",
        "description": "Fa w'adwene si ahomegye ne dadwen tew so"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "West African",
        "description": "Nigerian, Ghanaian, Senegalese nnuane"
      },
      "east_african": {
        "label": "East African",
        "description": "Kenyan, Ethiopian, Tanzanian nnuane"
      },
      "north_african": {
        "label": "North African",
        "description": "Moroccan, Egyptian nnuane"
      },
      "southern_african": {
        "label": "Southern African",
        "description": "South African nnuane"
      },
      "caribbean": {
        "label": "Caribbean",
        "description": "Jamaican, Trinidadian, Barbadian nnuane"
      },
      "middle_eastern": {
        "label": "Middle Eastern",
        "description": "Lebanese, Palestinian, Syrian nnuane"
      },
      "south_asian": {
        "label": "South Asian",
        "description": "Indian, Pakistani, Bangladeshi nnuane"
      },
      "east_asian": {
        "label": "East Asian",
        "description": "Chinese, Japanese, Korean nnuane"
      },
      "southeast_asian": {
        "label": "Southeast Asian",
        "description": "Thai, Vietnamese, Indonesian nnuane"
      },
      "western": {
        "label": "Western",
        "description": "American, European nnuane"
      },
      "latin_american": {
        "label": "Latin American",
        "description": "Mexican, Brazilian, Argentine nnuane"
      },
      "mediterranean": {
        "label": "Mediterranean",
        "description": "Greek, Italian, Spanish nnuane"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Amammere mu de",
        "description": "Nnuane a ɛfiri w’amammere mu kɛse"
      },
      "mixed": {
        "label": "Nnuane ahorow",
        "description": "Kura amammere ne amanɔne nnuane mu yiye"
      },
      "international": {
        "label": "Amanɔne de",
        "description": "Wiase nyinaa nnuane ahorow"
      }
    },
    "cuisines": {
      "west_african": "West African",
      "caribbean": "Caribbean",
      "mediterranean": "Mediterranean",
      "asian": "Asian",
      "western": "Western",
      "indian": "Indian",
      "middle_eastern": "Middle Eastern",
      "general": "Nnuane Ahorow Nyinaa"
    },
    "dietary": {
      "vegetarian": "Vegetarian",
      "vegan": "Vegan",
      "pescatarian": "Pescatarian",
      "gluten_free": "Gluten-Free",
      "dairy_free": "Dairy-Free",
      "low_carb": "Low-Carb"
    },
    "allergies": {
      "nuts": "Nkyekyere",
      "shellfish": "Mpoano nnuane",
      "dairy": "Milke nneɛma",
      "eggs": "Kosua",
      "soy": "Soy",
      "gluten": "Gluten"
    },
    "cuisine_nigerian": "Nigeria",
    "cuisine_ghanaian": "Ghana",
    "cuisine_senegalese": "Senegal",
    "cuisine_kenyan": "Kenya",
    "cuisine_ethiopian": "Ethiopia",
    "cuisine_moroccan": "Morocco",
    "cuisine_south_african": "South Africa",
    "cuisine_jamaican": "Jamaica",
    "cuisine_trinidadian": "Trinidad ne Tobago",
    "cuisine_lebanese": "Lebanon",
    "cuisine_turkish": "Turkey",
    "cuisine_greek": "Greece",
    "cuisine_italian": "Italy",
    "cuisine_french": "France",
    "cuisine_british": "Britain",
    "cuisine_indian_south": "Anafoɔ India",
    "cuisine_indian_north": "Atifi India",
    "cuisine_pakistani": "Pakistan",
    "cuisine_japanese": "Japan",
    "cuisine_chinese": "China",
    "cuisine_korean": "Korea",
    "cuisine_vietnamese": "Vietnam",
    "cuisine_thai": "Thailand",
    "cuisine_filipino": "Philippines",
    "cuisine_american": "America",
    "cuisine_mexican": "Mexico",
    "cuisine_brazilian": "Brazil",
    "cuisine_peruvian": "Peru"
  },
  "dashboard": {
    "welcome": "Akwaaba bio",
    "greeting": "Maakye",
    "goodMorning": "Anɔpa pa",
    "goodAfternoon": "Awia pa",
    "goodEvening": "Anwummere pa",
    "tagline": "Nanteɛ nkumaa ma apɔmuden tiri",
    "microcopy": "Wo apɔmuden kwan yi ho hia yie.",
    "welcomeSubtitleMorning1": "Anɔpa a ɛdwo.",
    "welcomeSubtitleMorning2": "Yɛni gye sɛ woaba ha anɔpa yi.",
    "welcomeSubtitleMorning3": "Nneɛma nkumaa na ɛkyerɛ pii.",
    "welcomeSubtitleAfternoon1": "Yɛhwɛ kwan sɛ wo awia yi rekɔ yie.",
    "welcomeSubtitleAfternoon2": "Akwaaba bio kɔ HealthLoop.",
    "welcomeSubtitleAfternoon3": "Home kakra — woyɛ adeɛ.",
    "welcomeSubtitleEvening1": "Yɛne wo rehome anwummere yi.",
    "welcomeSubtitleEvening2": "Anwummere a ɛdwo.",
    "welcomeSubtitleEvening3": "Akwaaba bio anwummere yi.",
    "title": "Wo Apɔmuden Ahobammɔ Afutuo Bea",
    "subtitle": "Hwehwɛ mu, sua, na yɛ ho hwee ansa na kɔm aba",
    "summary": "Wo Apɔmuden Nhunu Mu Nsɛm",
    "summaryDesc": "Nsɛm foforɔ wɔ ahobammɔ, nkyerɛkyerɛ, ne apɔmuden ho",
    "comprehensiveSupport": "Mmoa nyinaa wɔ ahobammɔ, nkyerɛkyerɛ, ne apɔmuden mu",
    "todayCheckIn": "Ɛnnɛ Nhwehwɛmu",
    "quickActions": "Yɛ ho hwee ntɛm",
    "healthOverview": "Apɔmuden Mu Nsɛm",
    "recentActivity": "Nneɛma a woayɛ nnansa yi",
    "viewAll": "Hwɛ ne nyinaa",
    "preventiveHealth": "Apɔmuden Ahobammɔ",
    "preventiveHealthDesc": "Hwehwɛ wo ho mu da biara na nya ahobammɔ nkaebɔ",
    "education": "Nkyerɛkyerɛ",
    "educationDesc": "Apɔmuden nsɛm ne afutuo a ɛfiri animfefoɔ hɔ",
    "engagement": "Nkitahodie",
    "engagementDesc": "Mpɔtam akansie, suban hwehwɛmu ne mmoa",
    "wellness": "Apɔmuden Pa",
    "wellnessDesc": "Aduane pa, nkwa mu nhyehyɛeɛ ne apɔmuden nyinaa",
    "todaysInsight": "Ɛnnɛ Nhunu",
    "wellnessScore": "Apɔmuden Akontaabu",
    "healthStreak": "Apɔmuden Nnaka",
    "days": "nna",
    "logHealth": "Twerɛ apɔmuden asɛm",
    "getEducated": "Sua pii",
    "communityChallenge": "Mpɔtam Akansie",
    "checkWellness": "Hwɛ apɔmuden mu",
    "verified": "Yɛahu sɛ ɛyɛ nokware",
    "joinCommunity": "Wura mpɔtam hɔ",
    "personalizedPlan": "Wo Ankasa Nhyehyɛeɛ",
    "score": "Akontaabu",
    "checkIns": "nhwehwɛmu",
    "habits": "suban",
    "preventive": "Ahobammɔ",
    "healthMetrics": "Apɔmuden Nsɛm",
    "trackMetrics": "Hwehwɛ nsɛm mu",
    "startTracking": "Fi ase hwehwɛ mu",
    "logMetrics": "Twerɛ nsɛm no",
    "dailyInsight": "Da Biara Nhunu",
    "learnAbout": "Sua apɔmuden ahobammɔ ho asɛm nnɛ",
    "articlesAvailable": "nsɛm a ɛwɔ hɔ",
    "browseArticles": "Kenkan nsɛm no",
    "currentStreak": "Nnaka a woawie",
    "keepGoing": "Kɔ so saa!",
    "startStreak": "Fi ase twerɛ nna no",
    "checkIn": "Hwɛ wo ho mu",
    "nutritionPlan": "Aduane Nhyehyɛeɛ",
    "mealsPlanned": "aduane a yɛahyehyɛ",
    "viewPlan": "Hwɛ nhyehyɛeɛ no",
    "planYourWeek": "Hyehyɛ wo nnawɔtwe",
    "moodStress": "Anigyeɛ & Dadwen",
    "howFeeling": "Wo ho te sɛn?",
    "logWellness": "Twerɛ wo ho asɛm",
    "medications": "Aduro",
    "noMeds": "Aduro biara nni mu",
    "addMedications": "Fa wo nnuro ka ho",
    "daysTracked": "Nna a yɛahwehwɛ mu",
    "noHabits": "Suban biara nni ha",
    "startTrackingHabits": "Fi ase hwehwɛ suban mu",
    "insights": "Nhunu",
    "noInsights": "Nhunu biara nni ha",
    "completeFirstPlan": "Wie wo nhyehyɛeɛ a ɛdi kan",
    "noCheckIns": "Nhwehwɛmu biara nni ha",
    "startFirstCheckIn": "Yɛ wo nhwehwɛmu a ɛdi kan"
  },
  "support": {
    "title": "Mmoa",
    "subtitle": "Nya mmuaeɛ, ne yɛn nni nkitaho",
    "backToSettings": "San kɔ nhyehyɛeɛ mu",
    "privacyBanner": "Mmoa nsɛm nyinaa yɛ kokoam deɛ. Wo ho asɛm bɛyɛ kokoam.",
    "section1": "Fa a ɛtɔ so 1",
    "section2": "Fa a ɛtɔ so 2",
    "section3": "Fa a ɛtɔ so 3",
    "section4": "Fa a ɛtɔ so 4",
    "navHelpCenter": "Mmoa Bea",
    "navContact": "Nkitahodie",
    "navHealth": "Apɔmuden Dwumadie",
    "navTechnical": "Mfiridwuma Mmoa",
    "helpCenterTitle": "Mmoa Bea",
    "helpCenterSubtitle": "Hwehwɛ mmuaeɛ ntɛm wɔ nsɛmmisa mu.",
    "contactTitle": "Nkitahodie",
    "contactSubtitle": "Ne yɛn nni nkitaho wɔ kwan a wopɛ so.",
    "healthServicesTitle": "Apɔmuden Dwumadie",
    "healthServicesSubtitle": "Ne animfefoɔ nni nkitaho wɔ aduro ho.",
    "technicalTitle": "Mfiridwuma Mmoa",
    "technicalSubtitle": "Kyerɛ mfomsoɔ biara a woahu.",
    "searchPlaceholder": "Hwehwɛ mmuaeɛ wɔ ha…",
    "liveChat": "Kasa nkitaho",
    "emailUs": "Twerɛ Email",
    "callBack": "Hyehyɛ berɛ ma yɛnfrɛ wo",
    "sendMessage": "Mane asɛm",
    "medicationTracking": "Aduro hwehwɛmu",
    "specialistAccess": "Animfefoɔ nkitaho",
    "videoConsultation": "Video nkitaho",
    "reportBug": "Kyerɛ mfomsoɔ bi",
    "yourName": "Wo din",
    "yourEmail": "Wo email",
    "subject": "Asɛmti",
    "message": "Asɛm no",
    "phone": "Tɛlɛfoni",
    "description": "Nkyerɛkyerɛmu",
    "submit": "Mane",
    "successTitle": "Yɛanya wo nsɛm",
    "successDescription": "Yɛbɛbua wo wɔ nnanhwere 24–48 mu.",
    "healthDisclaimer": "Sɛ asiane ba a, frɛ ayaresabea ntɛm. HealthLoop nyɛ oduruyɛfoɔ ananmuhyɛ."
  },
  "nutrition": {
    "smartNutrition": "Aduane Ho Nyansa",
    "basedOnGoal": "Egyina wo botaeɛ so:",
    "personalizedData": "Nea yɛahyehyɛ ama wo nnansa yi",
    "evidenceBased": "Aduane pa afutuo a ɛbɛbɔ wo ho ban",
    "todaysMealSuggestions": "Aduane a yɛkyerɛ nnɛ",
    "customize": "Sesa no",
    "breakfast": "Anɔpa duane",
    "lunch": "Awia duane",
    "dinner": "Anwummere duane",
    "loadingBreakfast": "Anɔpa duane reba...",
    "loadingLunch": "Awia duane reba...",
    "loadingDinner": "Anwummere duane reba...",
    "cal": "cal",
    "protein": "protein",
    "swapMeal": "Sesa aduane no",
    "healthyOptionsNearYou": "Aduane pa a ɛbɛn wo",
    "enableLocation": "Ma kwan mma yɛnhunu baabi a wowɔ",
    "view": "Hwɛ",
    "discoverOptions": "Hwehwɛ aduanebea ne sotɔɔ a ɛbɛn wo",
    "cuisinesSelected": "aduane a woayi",
    "cuisineSelected": "aduane a woayi",
    "dietaryPrefs": "aduane a wopɛ",
    "dietaryPref": "aduane a wopɛ",
    "customizeMeals": "Sesa wo nnuane",
    "subtitleAdaptive": "Aduane nhyehyɛeɛ a ɛfata wo amammere ne wo botaeɛ",
    "hideFavorites": "Suma deɛ m’ani gye ho",
    "viewFavorites": "Hwɛ deɛ m’ani gye ho",
    "customizeMealsLegacy": "Sesa wo nnuane ma ɛne w’amammere nhyia",
    "viewFullPlan": "Hwɛ nhyehyɛeɛ nyinaa",
    "exploreRecipes": "Hwehwɛ aduane no ho mmoa"
  },
  "location": {
    "permissionTitle": "Hwehwɛ aduane pa a ɛbɛn wo",
    "permissionDesc": "Yɛde bɛkyerɛ wo aduanebea ne sotɔɔ a ɛbɛboa wo apɔmuden.",
    "howToEnable": "Sɛnea wobɛma kwan:",
    "step1": "Mia kurokuro (lock) 🔒 a ɛwɔ soro hɔ no",
    "step2": "Hwehwɛ \"Location\" mma kwan no",
    "step3": "Sesa no kɔ \"Allow\"",
    "step4": "Horo saa krataa yi bio",
    "refreshPage": "Horo krataa yi bio",
    "allowLocation": "Ma ho kwan",
    "notNow": "Ɛnyɛ sesei",
    "denied": "Yɛantumi anhunu baabi a wowɔ. Sɛ wopɛ sɛ yehu a, ma ho kwan.",
    "unavailable": "Yɛnntumi nnya baabi a wowɔ mprempren. Hwɛ wo mfiri no mu.",
    "error": "Antumi anhu baabi a wowɔ. San bɔ mmɔden bio.",
    "unsupported": "Wo browser no mmoa saa dwumadie yi. Fa Chrome, Firefox, anaasɛ Safari.",
    "accessRequired": "Ɛsɛ sɛ yɛhu baabi a wowɔ"
  },
  "womensHealth": {
    "title": "Mmaa Apɔmuden",
    "description": "Hwehwɛ wo bosome afahyɛ mu, twerɛ sɛnea wo ho te, na nya afutuo pa",
    "cycleTracking": "Afahyɛ Hwehwɛmu",
    "symptomLogging": "Nsɛnkyerɛnneɛ Twerɛ",
    "phaseInsights": "Afahyɛ Nhunu",
    "logPeriod": "Twerɛ wo bosome afahyɛ",
    "logSymptoms": "Twerɛ nsɛnkyerɛnneɛ",
    "insights": "Nhunu",
    "tips": "Apɔmuden Afutuo",
    "overview": "Ne Nyinaa",
    "history": "Deɛ atwam",
    "startTracking": "Fi ase hwehwɛ wo bosome afahyɛ mu"
  },
  "profile": {
    "title": "Me Ho Asɛm",
    "personalInfo": "Me Ho Nsɛm",
    "healthProfile": "Apɔmuden Ho Nsɛm",
    "preferences": "Deɛ m’ani gye ho",
    "language": "Kasa",
    "selectLanguage": "Yi Kasa",
    "notifications": "Nkaebɔ",
    "privacy": "Kokoam Nsɛm",
    "security": "Ahobammɔ",
    "quickAccess": "Mfiase Ntɛm",
    "editProfile": "Sesa me ho asɛm",
    "viewStats": "Hwɛ akontaabu",
    "backToDashboard": "San kɔ Fie",
    "womensHealthTitle": "Mmaa Apɔmuden",
    "womensHealthDesc": "Bosome afahyɛ, nsɛnkyerɛnneɛ ne afutuo",
    "healthRemindersTitle": "Apɔmuden Nkaebɔ",
    "healthRemindersDesc": "Hwɛ wo nkaebɔ so",
    "manageRemindersDesc": "Hyehyɛ sɛnea wopɛ sɛ yɛbɔ wo kɔkɔ",
    "healthPatternAlerts": "Wo Apɔmuden Mu Kɔkɔbɔ",
    "supportHelp": "Mmoa",
    "supportHelpDesc": "Nya mmoa anaasɛ hwehwɛ nsɛmmisa mu",
    "admin": "Admin",
    "adminDesc": "Hwɛ sɛnea nkurɔfoɔ de dwumadie yi di dwuma",
    "giveFeedback": "Ma wo nyansafoɔ",
    "giveFeedbackDesc": "Kyerɛ w’adwene wɔ HealthLoop ho",
    "reportProblem": "Kyerɛ mfomsoɔ",
    "reportProblemDesc": "Boa yɛn ma yɛnyɛ app yi yie",
    "manageHealthInfo": "Hyehyɛ wo apɔmuden ahobammɔ nsɛm ma nhunu pa",
    "basicInformation": "Nsɛm Titiriw",
    "fullName": "Din Nyinaa",
    "email": "Email",
    "dateOfBirth": "Awoɔda",
    "gender": "Barima anaasɛ Baa",
    "height": "Tentene (cm)",
    "weight": "Mu duru (kg)",
    "medicalConditions": "Yadeɛ a wowɔ",
    "allergies": "Aduane/Nneɛma a ɛnne wo",
    "personalHealth": "Me Apɔmuden",
    "addCondition": "Fa yadeɛ bi ka ho",
    "addAllergy": "Fa deɛ ɛnne wo ka ho",
    "saveChanges": "Kora nsakraeɛ no so",
    "saving": "Ɛrekora so...",
    "privacyMessage": "Wo ho nsɛm nyinaa yɛ kokoam deɛ a ahobammɔ wom"
  },
  "settings": {
    "title": "Nfitiaseɛ",
    "general": "Sɛnea ɛteɛ",
    "account": "Wo akawnt",
    "appearance": "Sɛnea ɛyɛ mfe",
    "languageSettings": "Kasa nkyekyɛmu",
    "changeLanguage": "Sesasɛ kasa",
    "languageNote": "Nkyerɛaseɛ no nyinaa bɛba nnansa yi ara. Sɛ wopa kasa foforo a, mfonini no bɛsesa.",
    "languageUpdated": "Yɛasesa kasa no yie"
  },
  "search": {
    "triggerLabel": "Hwehwɛ HealthLoop mu",
    "triggerHint": "Sɔ \"anammɔn\", \"aduruyɛbea\" anaa \"nyinsɛn\" hwɛ",
    "triggerAriaLabel": "Bue hwehwɛbea kɛseɛ no",
    "placeholder": "Hwehwɛ nnoɔma, nkɔsoɔ-hwehwɛfoɔ, mmoa…",
    "inputAriaLabel": "Hwehwɛ HealthLoop nnoɔma",
    "modalAriaLabel": "Hwehwɛ HealthLoop",
    "close": "To mu",
    "clear": "Popa mu",
    "clearAriaLabel": "Popa hwehwɛbea no mu",
    "recentSearches": "Nnoɔma a wahwehwɛ nnansa yi",
    "tryFor": "Sɔ yei hwehwɛ hwɛ",
    "findFeatures": "Hunu adeɛ biara simma kakra bi mu.",
    "searchAcross": "Hwehwɛ wɔ",
    "and": "ne",
    "sections": {
      "home": "Fie",
      "nutrition": "Aduane pa",
      "family": "Abusua",
      "services": "Nnwuma",
      "support": "Mmoa",
      "profile": "Me ho nsɛm"
    },
    "noMatchesFor": "Yɛanhunu biribiara ama \"{{query}}\"",
    "trySimpler": "Sɔ asɛmfua a ɛnyɛ den te sɛ anammɔn, aduane pa anaa ɔyarehwɛfoɔ hwɛ.",
    "comingSoonBadge": "Ɛreba nkyɛɛ",
    "escToClose": "na woato mu",
    "resultSingular": "Adeɛ {{count}} na yɛahu",
    "resultPlural": "Nnoɔma {{count}} na yɛahu",
    "searchAcrossApp": "Hwehwɛ app yi nyinaa mu"
  },
  "familyMember": {
    "confirmRemove": "Wopɛ sɛ woyi {{name}} firi abusua akwahosan nhyehyɛeɛ no mu?",
    "removed": "Yayi {{name}} afiri abusua no mu",
    "removeFailed": "Yɛantumi anyi nipa no",
    "viewDetails": "Hwɛ emu nsɛm",
    "edit": "Sesa no",
    "remove": "Yi firi mu",
    "yearsSuffix": "mfeɛ",
    "healthGoalsLabel": "Akwahosan botaeɛ:",
    "moreSuffix": "bi ka ho",
    "activeInsights": "Akwahosan ho afutuo",
    "viewAllInsights": "Hwɛ afutuo {{count}} no nyinaa →",
    "viewFullProfile": "Hwɛ akwahosan ho nsɛm nyinaa",
    "lifeStage": {
      "infant": "Akokoaa (0-2)",
      "toddler": "Abofra a ɔrekasa (2-5)",
      "child": "Abofra (6-12)",
      "adolescent": "Aberanteɛ/Ababaawa (13-17)",
      "adult": "Panin (18-59)",
      "senior": "Akora/Aberewa (60+)",
      "unknown": "Yɛnnim"
    }
  },
  "profileDeep": {
    "backToDashboard": "San kɔ anim",
    "profileCompletion": "Wo ho nsɛm a woawie",
    "healthSummary": "Wo ho nsɛm nyinaa",
    "sectionA": "Fa firi A",
    "sectionB": "Fa firi B",
    "sectionC": "Fa firi C",
    "sectionD": "Fa firi D",
    "personalDetails": "Wo ho nsɛm ankasa",
    "healthInformation": "Wo ho apɔmuden nsɛm",
    "accountSettings": "Akawnt nkyekyɛmu",
    "fullName": "Wo din nyinaa",
    "email": "Imeyili",
    "dob": "Wo mofie afahyɛ",
    "gender": "Bɔbeasu",
    "genderPlaceholder": "e.g., Obiaa, Ɔbarima, Deɛ ɛda mfinimfini",
    "height": "Wo tenten (cm)",
    "heightPlaceholder": "e.g., 170",
    "weight": "Wo duru (kg)",
    "weightPlaceholder": "e.g., 70",
    "allergies": "Deɛ ɛnyɛ ma wo nipaduua",
    "allergiesPlaceholder": "e.g., Nkatie",
    "medicalConditions": "Yadeɛ biara a wowɔ",
    "conditionsPlaceholder": "e.g., Mogya mmoroso",
    "medications": "Aduro a wonom",
    "medicationsPlaceholder": "e.g., Lisinopril 10mg, daa",
    "emergencyContact": "Obi a yɛbɛfrɛ no amanehunu mu",
    "emergencyOptional": "(sɛ wopɛ a)",
    "emergencyPlaceholder": "e.g., Maame +1-555-0100",
    "emergencyNote": "Yɛde bɛma aduruyɛfoɔ sɛ woapene so nkoaa.",
    "saveChanges": "Sie nsakraeɛ no",
    "saving": "Ɛresie…",
    "editProfile": "Sesa wo ho nsɛm",
    "cancelEditing": "Gyae nsakraeɛ no",
    "healthScore": "Apɔmuden gyinabea",
    "streak": "Nna a woadi so",
    "streakDays": "Nna {{n}}",
    "memberSince": "Woyɛ ɛkuoba firi",
    "remindersActive": "Nkaebɔ no reyɛ adwuma",
    "conditionsTracked": "Yadeɛ a yɛrehwɛ",
    "nextAgenda": "Deɛ ɛdi hɔ ma wo",
    "notificationsReminders": "Nkaebɔ ne nnyigyeɛ",
    "notificationsRemindersDesc": "Siesie bere ne kwan a yɛfa so kae wo apɔmuden ho",
    "emailNudges": "Imeyili nkaebɔ",
    "emailNudgesDesc": "Nkaebɔ a ɛyɛ mmerɛ ne nnawɔtwe mu nsɛm",
    "on": "Ɛreyɛ adwuma",
    "paused": "Yɛagyae mu kakra",
    "privacySecurity": "Kokoamsɛm ne ahobammɔ",
    "privacySecurityDesc": "Sesa wo 'password' na wo akawnt ho abɔ",
    "preferencesTitle": "Deɛ wopɛ",
    "preferencesDesc": "Kasa, mpɔtam, ne nsɛm a ɛfa wo ho",
    "supportHelp": "Mmoa ne nkyerɛkyerɛmu",
    "supportHelpDesc": "Nya mmuaeɛ na kɔ yɛn nkyɛn",
    "giveFeedback": "Kyerɛ w’adwene",
    "giveFeedbackDesc": "Kyerɛ yɛn deɛ yɛnsiesie",
    "reportProblem": "Bɔ amaneɛ sɛ biribi mfata",
    "reportProblemDesc": "Wohu mfomsoɔ bi? Kyerɛ yɛn",
    "adminInsights": "Adwumayɛfoɔ nhwɛsodeɛ",
    "adminInsightsDesc": "Sɛnea nkurɔfoɔ de dwumadie no di dwuma",
    "adminBadge": "Adwumayɛfoɔ",
    "shareWithClinician": "Kyɛ kyerɛ aduruyɛfoɔ",
    "shareWithClinicianDesc": "Wo ho nsɛm a obi bɛtumi akenkan nkoaa · ɛbɛpa ho nna kakra akyi · wotumi gyae mu bere biara",
    "share": "Kyɛ",
    "profileMayBeOutOfDate": "Ebia wo ho nsɛm no ayɛ dada",
    "profileMayBeOutOfDateDesc": "Ma wo ho nsɛm nnyina hɔ pɛpɛɛpɛ na yanya akwankyerɛ pa ama wo — nsakraeɛ nketewa mpo (sɛnea wo duru teɛ, aduro foforo) boa yɛn.",
    "updateNow": "Sesa no seesei",
    "profileUpdateError": "Yɛantumi ansiesie deɛ wopɛ no. Yɛ no bio.",
    "healthLoopUser": "HealthLoop dwumadifoɔ",
    "updatedLabel": "Yɛasiesie no",
    "noEntries": "Biribiara nni ha seesei.",
    "completionComplete": "Woawie wo ho nsɛm siesie. Seesei yɛbɛtumi ama wo akwankyerɛ a ɛyɛ paa. 💚",
    "completionAlmostThere": "Aka kakra. Nsɛm kakra bi bɛma woanya akwankyerɛ a ɛmu dɔ.",
    "completionInProgress": "Wie wo ho nsɛm na nya apɔmuden akwankyerɛ pa.",
    "justNow": "seesei ara",
    "minAgo": "miniti {{n}} a atwam",
    "minsAgo": "miniti {{n}} a atwam",
    "hourAgo": "dɔnhwere {{n}} a atwam",
    "hoursAgo": "ndɔnhwere {{n}} a atwam",
    "dayAgo": "da {{n}} a atwam",
    "daysAgo": "nna {{n}} a atwam",
    "checkinDueToday": "Ɛsɛ sɛ wohwɛ wo ho nnɛ",
    "checkinDueTonight": "Ɛsɛ sɛ wohwɛ wo ho anadwo yi"
  },
  "supportDeep": {
    "backToSettings": "San kɔ nkyekyɛmu",
    "quickNavAria": "Mmoa nkyekyɛmu",
    "searchPlaceholder": "Hwehwɛ mmoa…",
    "searchAria": "Hwehwɛ nsɛmmisa a nkurɔfoɔ taa bisa",
    "resultsCount": "mmuaeɛ {{n}}",
    "resultsCountPlural": "mmuaeɛ {{n}}",
    "questionsCount": "nsɛmmisa {{n}}",
    "liveChatTitle": "Kasa seesei",
    "liveChatDesc": "Kasa kyerɛ yɛn seesei ara · Dwoda–Efiada 9am–6pm",
    "startChat": "Fi nkɔmmɔbɔ no ase",
    "liveChatSoonToast": "Yɛbɛba akɔmmɔbɔ no ase nnansa yi ara. Seesei deɛ, imeyili bɛyɛ adwuma yie.",
    "emailUsTitle": "Kyerɛw yɛn imeyili",
    "emailUsDesc": "Yɛbɛbua wo mmerɛ 24–48 mu",
    "copy": "Twa mfonini",
    "emailCopied": "Yɛatwa imeyili no afa.",
    "contactFormTitle": "Nkɔmmɔbɔ Krataa",
    "contactFormDesc": "Mane yɛn nkra — yɛbɛfa imeyili so abua wo.",
    "yourNameLabel": "Wo din *",
    "namePlaceholder": "Jane Doe",
    "yourEmailLabel": "Wo imeyili *",
    "emailPlaceholder": "jane@example.com",
    "subjectOptional": "Asɛm no ti (sɛ wopɛ a)",
    "subjectPlaceholder": "Dɛn na yɛmmoa wo?",
    "messageLabel": "Nkra *",
    "messagePlaceholder": "Kyerɛ yɛn deɛ wohia ho mmoa kakra.",
    "sending": "Ɛrekɔ…",
    "sendMessage": "Mane Nkra",
    "messageSent": "Nkra no akɔ",
    "messageSentDesc": "Yɛbɛbua wo mmerɛ 24–48 mu.",
    "callbackTitle": "Srɛ ma yɛnfrɛ wo",
    "callbackDesc": "Yɛbɛfrɛ wo bio wɔ bere a ɛbɛyɛ ma wo.",
    "phoneLabel": "Wo tɛlifon namba *",
    "phonePlaceholder": "+1 (555) 123-4567",
    "preferredTimeLabel": "Bere a wopɛ (sɛ wopɛ a)",
    "preferredTimePlaceholder": "e.g. ɔkyena awia",
    "reasonLabel": "Ɛho ntia (sɛ wopɛ a)",
    "reasonPlaceholder": "Dɛn na wopɛ sɛ yɛka ho asɛm?",
    "submitting": "Ɛrekɔ…",
    "requestCallback": "Srɛ frɛ",
    "callbackRequested": "Yɛanya wo frɛ srɛ",
    "callbackRequestedDesc": "Yɛbɛfrɛ wo mmerɛ 24 mu.",
    "medicationSupport": "Aduro ho Mmoa",
    "medicationSupportDesc": "Hwɛ aduro a woretɔ, aduro foforo, ne nkaebɔ.",
    "goToMedications": "Kɔ aduro nkyɛn →",
    "specialistConsultation": "Duruyɛfoɔ a ɔnim adwuma",
    "specialistConsultationDesc": "Kasa kyerɛ aduruyɛfoɔ na woanya apɔmuden akwankyerɛ pa.",
    "connectExpert": "Kɔ obi a ɔnim adwuma nkyɛn →",
    "videoConsult": "Kasa wɔ mfonini so",
    "videoConsultDesc": "Fa mfonini so na hyehyɛ bere na wo ne oduruyɛfoɔ nkasa.",
    "bookConsultation": "Hyehyɛ bere →",
    "premium": "Soronko",
    "healthDisclaimer": "HealthLoop boa wo daa apɔmuden — ɛnyɛ amanehunu berɛ mu duruyɛ adwuma. Sɛ biribi hyɛ wo so a, yɛsrɛ wo frɛ wo mpɔtam hɔ amanehunu dwumadibea.",
    "categoryLabel": "Nkyekyɛmu",
    "catBug": "Mfomsoɔ bi",
    "catPerformance": "Ɛreyɛ nyaanyaa",
    "catFeature": "Dwumadie bi nyɛ adwuma",
    "catUi": "Mfonini no mfata",
    "catOther": "Deɛ ɛka ho",
    "issueTitle": "Asɛm no ti *",
    "issueTitlePlaceholder": "Asɛm no mu nsɛm kakra",
    "detailedDescription": "Nkyerɛkyerɛmu a ɛmu dɔ *",
    "detailedDescriptionPlaceholder": "Dɛn na ɛsiiɛ? Dɛn na woreyɛ berɛ a ɛsiiɛ? Sɛn na yɛbɛyɛ na yɛahu bio — ɛbɛboa yɛn paa.",
    "autoAttachNote": "Wo 'device' ne 'browser' ho nsɛm bɛka ho ara.",
    "submitReport": "Mane amaneɛbɔ no",
    "reportSubmitted": "Amaneɛbɔ no akɔ",
    "reportSubmittedDesc": "Yɛn kuo no reyɛ ho adwuma.",
    "fillAllFields": "Yɛsrɛ wo hyɛ baabi a ɛhia nyinaa ma",
    "problemReportSubmittedToast": "Amaneɛbɔ no akɔ. Yɛbɛhwehwɛ mu na yɛabua wo nnansa yi ara.",
    "messageSentToast": "Nkra no akɔ. Yɛbɛbua wo mmerɛ 24–48 mu.",
    "callRequestedToast": "Yɛanya wo frɛ srɛ. Yɛbɛfrɛ wo mmerɛ 24 mu.",
    "submitFailGeneric": "Ankɔ. Yɛsrɛ wo yɛ no bio anaasɛ kyerɛw {{email}}.",
    "submitFailContact": "Ankɔ. Yɛsrɛ wo kyerɛw {{email}}.",
    "comingSoon": "Ɛbɛba nnansa yi",
    "specialistRoadmapTitle": "Kasa kyerɛ Oduruyɛfoɔ",
    "specialistRoadmapSubtitle": "Mmoa bɛba nnansa yi ara. Dwumadie yi bɛba ha na mmoa abɛn wo.",
    "talkToSpecialistTitle": "Kasa kyerɛ Oduruyɛfoɔ",
    "talkToSpecialistDesc": "Kasa kyerɛ aduruyɛfoɔ a wɔwɔ tumi krataa wɔ apɔmuden nsɛm ho.",
    "bookSpecialistTitle": "Hyehyɛ bere ma Oduruyɛfoɔ",
    "bookSpecialistDesc": "Hyehyɛ bere na wo ne oduruyɛfoɔ a ɔbɛboa wo bɔtaeɛ nkasa.",
    "liveHealthGuidanceTitle": "Apɔmuden Akwankyerɛ Seesei",
    "liveHealthGuidanceDesc": "Mfonini so akwankyerɛ ma yadeɛ ho nsɛnkyerɛnne, 'lab' mmuaeɛ, anaasɛ sɛnea wopue yadeɛ mu.",
    "mentalWellnessTitle": "Adwene ne Ahomete Mmoa",
    "mentalWellnessDesc": "Kokoam mmoa firi adwene mu apɔmuden ho animdefoɔ hɔ.",
    "wellnessNavigationTitle": "Apɔmuden Akwankyerɛ Kwan",
    "wellnessNavigationDesc": "Akwankyerɛ a ɛbɛboa wo na woahunu deɛ ɛsɛ sɛ woyɛ a ɛdi hɔ.",
    "pharmacyRoadmapTitle": "Aduro ne Adutɔnbea Mmoa",
    "pharmacyRoadmapSubtitle": "Adutɔnbea ho mmoa bɛba mmoa nkyekyɛmu no mu.",
    "medicationGuidanceTitle": "Aduro ho Akwankyerɛ",
    "medicationGuidanceDesc": "Kasa a ɛmu da hɔ wɔ aduro dodow, bere, ne dɔm mu aduro ho.",
    "findNearbyPharmacyTitle": "Hunu Adutɔnbea a ɛbɛn wo",
    "findNearbyPharmacyDesc": "Hunu adutɔnbea a yɛtumi de yɛn ho to wɔn so ntɛm.",
    "refillReminderTitle": "Aduro foforo ho Nkaebɔ",
    "refillReminderDesc": "Nkaebɔ a ɛbɛma woahunu na aduro biara ampa wo nsa.",
    "otcWellnessTitle": "Aduro a wonom a duruyɛfoɔ nkyerɛwee",
    "otcWellnessDesc": "Akwankyerɛ a ɛfa aduro a ɛyɛ na ahobammɔ wom a yɛtɔ no kwa ho."
  },
  "careServices": {
    "pageTitle": "Mmoa Dwumadie",
    "pageSubtitle": "Aduruyɛ ne apɔmuden mmoa a yɛayɛ ama wo daa apɔmuden akwantuo.",
    "specialistCareTitle": "Aduruyɛfoɔ Soronko",
    "specialistCareSubtitle": "Kasa kyerɛ aduruyɛfoɔ na hyehyɛ bere ma obi a ɔbɛboa wo.",
    "medicationPharmacyTitle": "Aduro ne Adutɔnbea",
    "medicationPharmacySubtitle": "Aduro ho akwankyerɛ a ɛmu da hɔ ne adutɔnbea ho mmoa.",
    "wellnessSupportTitle": "Apɔmuden Mmoa",
    "wellnessSupportSubtitle": "Adwene mu apɔmuden, aduro ho akwankyerɛ, ne akwan a ɛda hɔ.",
    "futureWellnessTitle": "Apɔmuden Dwumadie a ɛreba",
    "futureWellnessSubtitle": "Deɛ ɛbɛba HealthLoop apɔmuden dwumadie mu nnansa yi.",
    "futureFeatureBadge": "Dwumadie a ɛreba",
    "futurePersonalizedMealsTitle": "Aduane nkyekyɛmu a ɛfa wo ho",
    "futurePersonalizedMealsDesc": "Aduane nhyehyɛeɛ a ɛfa wo bɔtaeɛ, deɛ wonni, ne w'amammerɛ ho.",
    "futureHealthyDeliveryTitle": "Aduane pa a yɛde ba fie",
    "futureHealthyDeliveryDesc": "Aduane a yɛayi firi adidibea a wɔdwene apɔmuden ho.",
    "futureFarmFreshTitle": "Afuom aduane a ɛfiri foforo",
    "futureFarmFreshDesc": "Kwan a ɛkɔ mfuom ne mpɔtam hɔ aduane pa nkyɛn tẽẽ.",
    "futureFoodPartnershipsTitle": "Aduane pa ayɔnkofa",
    "futureFoodPartnershipsDesc": "Ayɔnkofa a ɛda adidibea pa, 'grocers', ne apɔmuden afã horow ntam.",
    "futureNutritionCoachingTitle": "Aduane ho nteteeɛ",
    "futureNutritionCoachingDesc": "Akwankyerɛ firi animdefoɔ a wɔnim aduane pa ho asɛm nkyɛn.",
    "futureFamilyWellnessTitle": "Abusua apɔmuden nhyehyɛeɛ",
    "futureFamilyWellnessDesc": "Nhyehyɛeɛ a ɛbɛma abusua mufoɔ nyinaa anya apɔmuden.",
    "futureWellnessPlusTitle": "Wellness+ Membership",
    "futureWellnessPlusDesc": "Dwumadie soronko ma akwankyerɛ a ɛmu dɔ ne mmoa a ɛdi kan.",
    "futurePharmacyPartnersTitle": "Adutɔnbea Ayɔnkofa",
    "futurePharmacyPartnersDesc": "Adutɔnbea pa a wɔbɛboa wo wɔ aduro ho akwankyerɛ mu.",
    "futureAdvancedSpecialistTitle": "Aduruyɛfoɔ a wɔkɔ akyiri",
    "futureAdvancedSpecialistDesc": "Kwan a yɛfa so kɔ aduruyɛfoɔ nkyɛn na yanya adwene foforo.",
    "futureWellnessMarketplaceTitle": "Apɔmuden Edwa",
    "futureWellnessMarketplaceDesc": "Baabi a yɛatwa apɔmuden nneɛma ne dwumadie pa ho mfonini.",
    "futureVendorCollabTitle": "Adwumayɛfoɔ mmoa nhyehyɛeɛ",
    "futureVendorCollabDesc": "Nhyehyɛeɛ a ɛbɛma aduane pa ne apɔmuden adwumayɛfoɔ anya mmoa."
  },
  "dashboardDeep": {
    "healthProfile": "Apɔmuden Nsɛm",
    "notifications": "Nkaebɔ",
    "familyAccounts": "Abusua Akawnt",
    "settings": "Nkyekyɛmu",
    "logout": "Fue mu kɔ",
    "allCaughtUp": "Woawie biribiara.",
    "weekInReview": "Wo nnawɔtwe mu nsɛm",
    "dismissNotification": "Yi nkaebɔ yi kɔ",
    "dismissWeeklyDigest": "Yi nnawɔtwe mu nsɛm yi kɔ",
    "notificationsAria": "Nkaebɔ",
    "profileMenuAria": "Bue wo ho nsɛm",
    "loadingWellness": "Yɛrehwehwɛ wo apɔmuden nsɛm",
    "nextTip": "Afutuo a ɛdi hɔ",
    "todayAtGlance": "Ɛnnɛ mu nsɛm kakra",
    "healthScoreLabel": "Apɔmuden Gyinabea",
    "currentStreakLabel": "Nna a woadi so",
    "todaysProgress": "Ɛnnɛ nkɔsoɔ",
    "insightForYou": "Akwankyerɛ ma wo",
    "checkMyHealthRisk": "Hwɛ m'apɔmuden amanehunu",
    "quickAccess": "Kwan ntɛm",
    "exploreCareServicesTitle": "Hwehwɛ Mmoa Dwumadie mu",
    "exploreCareServicesSubtitle": "Aduruyɛfoɔ · adutɔnbea · apɔmuden — ɛwɔ baabi koro.",
    "familyCare": "Abusua Mmoa",
    "healthLibrary": "Apɔmuden Nwoma",
    "myHealthData": "Me Ho Nsɛm",
    "askQuestion": "Bisa Asɛmmisa",
    "dashLoadError": "Yɛantumi ammue wo dwumadie anim. Yɛ no bio.",
    "taskUpdateError": "Yɛantumi ansiesie adwuma no. Yɛ no bio.",
    "perfectDay": "Da pa! 🎉 Woadi so bio.",
    "letsStart": "Ma yɛnhyɛ aseɛ",
    "yourNextStepToday": "W'anammɔn a ɛdi hɔ nnɛ",
    "completeDailyCheck": "Wie wo daa apɔmuden nhwehwɛmu",
    "startDailyCheck": "Hyɛ daa nhwehwɛmu ase",
    "viewAll": "Hwɛ ne nyinaa",
    "graceProtected": "Yɛasiesie mmerɛ ama wo",
    "todaysHealthRecommendations": "Ɛnnɛ Apɔmuden Afutuo",
    "updateViaCheck": "Sesa no firi daa nhwehwɛmu no mu",
    "healthInsight": "Apɔmuden Akwankyerɛ",
    "riskCheckSubtext": "Nya apɔmuden akwankyerɛ ntɛm ara",
    "foodDiet": "Aduane & Adidie",
    "healthScoreNew": "Apɔmuden Gyinabea · Foforo",
    "letsBuildScore": "Ma yɛmmoa wo apɔmuden gyinabea",
    "oneHealthyHabitAtATime": "Suban pa koro biara bere biara.",
    "nextCheck": "Nhwehwɛmu a ɛdi hɔ:",
    "todayAt8pm": "nnɛ 8:00 PM",
    "wellnessTipForYou": "Ɛnnɛ Apɔmuden Afutuo · Ma wo",
    "wellnessTipForFactor": "Ɛnnɛ Apɔmuden Afutuo · Fa wo {{factor}} ho",
    "logged": "Yɛatwerɛ",
    "gotIt": "Mate ase 👍",
    "gladToSeeYou": "Yɛn ani agye sɛ yɛahu wo nnɛ 💚",
    "takesLessThan60Sec": "Ennye miniti koro mpo",
    "scoreReadyWhenYou": "Ɛasiesie ama wo",
    "scoreCompleteFirstCheck": "Wie wo nhwehwɛmu a ɛdi kan na woanya akwankyerɛ pa.",
    "scoreExcellent": "Ɛyɛ paa",
    "scoreSupportExcellent": "Woapɔmuden te sɛ deɛ ɛsɛ nnɛ. Kɔ so saa.",
    "scoreGood": "Ɛyɛ",
    "scoreSupportGood": "Wobɔ mmɔden. Kɔ so kura wo suban pa mu.",
    "scoreModerate": "Ɛnyɛ koraa",
    "scoreSupportModerate": "Wobɔ mmɔden, nanso nneɛma kakra hia mmoa.",
    "scoreNeedsAttention": "Hia mmoa",
    "scoreSupportNeedsAttention": "Woapɔmuden hia mmoa nnɛ. Nsakraeɛ nketewa bɛboa wo."
  },
  "emailVerify": {
    "bannerWithEmail": "Yɛsrɛ wo siesie wo imeyili ({{email}}) na wo akawnt ho abɔ na yɛanya kwan amane wo nkaebɔ.",
    "bannerNoEmail": "Yɛsrɛ wo siesie wo imeyili na wo akawnt ho abɔ na yɛanya kwan amane wo nkaebɔ.",
    "sending": "Ɛrekɔ…",
    "resend": "San mane imeyili no",
    "sentToast": "Yɛamane imeyili no. Yɛsrɛ wo hwɛ wo 'inbox'.",
    "sendFailToast": "Yɛantumi amane imeyili no. Yɛ no bio akyire yi."
  },
  "forgotPassword": {
    "title": "Woawerefi wo 'Password'?",
    "subtitle": "Ɛnyɛ hwee! Hyɛ wo imeyili mu na yɛbɛmane wo akwankyerɛ.",
    "emailLabel": "Imeyili Adrɛse",
    "emailPlaceholder": "your.email@example.com",
    "sendResetLink": "Mane 'Link' no",
    "sending": "Ɛrekɔ…",
    "backToLogin": "San kɔ baabi a yɛhyɛ mu",
    "resendLink": "San mane imeyili no",
    "successTitle": "Hwɛ wo Imeyili",
    "successBody": "Sɛ akawnt bi wɔ hɔ ma {{email}} a, yɛamane 'password reset link' no.",
    "linkExpires": "Link yi bɛpa ho mmerɛ 30 akyi.",
    "successToast": "Hwɛ wo imeyili na woahu akwankyerɛ no",
    "errEmptyEmail": "Yɛsrɛ wo hyɛ wo imeyili mu",
    "errInvalidEmail": "Yɛsrɛ wo hyɛ imeyili a ɛyɛ mu",
    "errNetwork": "Yɛantumi ankɔ 'server' no so. Hwɛ wo 'connection' na yɛ no bio.",
    "errGeneric": "Yɛantumi amane imeyili no. Yɛ no bio anaasɛ frɛ mmoa."
  },
  "resetPassword": {
    "title": "Hyehyɛ 'Password' Foforo",
    "subtitle": "Yɛ 'password' a ɛyɛ den ma wo akawnt",
    "newPasswordLabel": "Password Foforo",
    "newPasswordPlaceholder": "Hyɛ password foforo no mu",
    "confirmPasswordLabel": "Si 'Password' no so dua",
    "confirmPasswordPlaceholder": "San hyɛ password foforo no mu",
    "requirementsHint": "Ɛsɛ sɛ nkyerɛwee no boro nwɔtwe (8) na nkyerɛwee kɛseɛ, ketewa, ne namba wom",
    "resetPassword": "Sesa Password",
    "resetting": "Ɛresesa…",
    "successTitle": "Yɛasesa Password no yie!",
    "successBody": "Seesei wotumi de wo password foforo no hyɛ mu.",
    "successToast": "Yɛasesa password no yie!",
    "goToLogin": "Kɔ baabi a yɛhyɛ mu",
    "invalidLinkTitle": "Link no nyɛ",
    "invalidLinkBody": "Saa reset link yi mfata anaasɛ apa ho.",
    "requestNewLink": "Srɛ Link foforo",
    "showPassword": "Kyerɛ password no",
    "hidePassword": "Suma password no",
    "errInvalidLink": "Link no mfata",
    "errMismatch": "Password no nhyia",
    "errTooShort": "Password no nsuane nkyerɛwee nwɔtwe",
    "errExpiredToken": "Link yi apa ho anaasɛ mfata. Yɛsrɛ wo srɛ foforo.",
    "errNetwork": "Yɛantumi ankɔ 'server' no so. Hwɛ wo 'connection' na yɛ no bio.",
    "errGeneric": "Yɛantumi ansesa password no. Yɛ no bio."
  },
  "tips": {
    "water1": "Sɛ wonom nsuo mmerɛ 30 mu bere a woanyan a, ɛboa wo nipaduua ne w'ahoɔden.",
    "water2": "Nsuo kuruwa koro ansa na woadidi yɛ kwan pa a wofa so ma nsuo tene wo mu.",
    "water3": "Sɛ wode 'lemon' anaasɛ 'mint' hwiren gu nsuo mu a, ɛma nsuo nom yɛ dɛ.",
    "meals1": "Sɛ wode nnuaba ne nhaba ka w'aduane ho daa a, ɛboa wo mmerɛbo ne wo koma.",
    "meals2": "Nkatie anaasɛ 'seeds' kakra a wode bɛdi anɔpa duane bɛma w'ahoɔden asoa wo mmerɛ tenten.",
    "meals3": "Nnuaba ankasa di ye sen nsuo a yɛafi mu — 'fibre' no boa wo mogya mu asikyire.",
    "steps1": "Miniti 10 nanteɛ adidie akyi boa wo nipaduua ma ɛyam asikyire mmerɛ.",
    "steps2": "Miniti 5 anɔpa ntinnisoɔ tew haw so na ɛma wo da no fi ase dɔm mu.",
    "steps3": "Sɛ wode 'stairs' di dwuma mpo baako da koro a, ɛma wo koma yɛ den berɛ kɔ so.",
    "sleep1": "Sɛ wudum nkanea dɔnhwere koro ansa na woada a, ɛma wonya nna pa.",
    "sleep2": "Sɛ wonyan bere koro daa — mpo 'weekends' — a, ɛboa wo nna nhyehyɛeɛ.",
    "sleep3": "Miniti 10 anɔpa awia boa ma wo nna nhyehyɛeɛ kɔ yie pɛpɛɛpɛ.",
    "general1": "Miniti mmienu a wode bɛhome brɛoo bɛtumi ate adwumayɛ mu haw so na ama w'adwene asi pi.",
    "general2": "Hyɛ deɛ ɛyɛ biara nso nnɛ — nkunim nketewa wɔ adwene mu boa paa.",
    "general3": "Wobɛyɛɛ deɛ ɛsɛ nnɛ. Saa suban yi na ɛma suban afoforo nyinaa yɛ mmerɛ."
  },
  "factors": {
    "hydration": "nsuo a wonom",
    "nutrition": "aduane pa",
    "movement": "nipaduua nanteɛ",
    "sleep": "nna"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "Yentumi ne aduane no ammma",
    "prefsSaved": "Yɛakora w'aduane fɛm mpanimfoɔ so! Yɛresiesie mmeae no...",
    "prefsSaveFail": "Yɛntumi ankora w'aduane fɛm mpanimfoɔ so",
    "newOptionsFail": "Yɛntumi amfa nneɛma foforɔ ammma",
    "invalidZip": "Yɛsrɛ wo, hyɛ postcode/zip code a ɛfata",
    "noVendorsArea": "Yɛnyaa aduanetonfoɔ biara wɔ baabi a wowɔ yi. Yɛregu mu trɛ!",
    "vendorsFetchFail": "Yɛntumi nnya aduanetonfoɔ no",
    "selectVendorFirst": "Yɛsrɛ wo, yi obi a ɔde aduane bɛbrɛ wo ansa",
    "removedFromCart": "Yɛayi afiri nneɛma a wopɛ sɛ wotɔ no mu",
    "orderPlaced": "W'aduane tɔ no akɔ yie! 🎉",
    "enterZipFirst": "Yɛsrɛ wo, hyɛ wo postcode ansa wɔ faako a yɛkyerɛ baabi a yɛde aduane bɛbrɛ wo no",
    "mealNotAvailable": "Yɛntumi mfa aduane yi mmra baabi a wowɔ yi",
    "mealUnavailable": "Aduanetonfoɔ a wɔbɛn wo no nni aduane yi seesei",
    "vendorOptionsFail": "Yɛntumi nnya aduanetonfoɔ foforɔ",
    "favoriteSaveFail": "Yɛntumi ankora aduane a wopɛ yi so",
    "removedFromFavorites": "Yɛayi afiri w'aduane a wopɛ no mu",
    "favoriteRemoveFail": "Yɛntumi nyi aduane a wopɛ no mfiri mu",
    "cartEmpty": "W'aduane tɔ kɛntɛn no mu da hɔ",
    "noMealOptions": "Aduane biara nni hɔ a wubumi ayi",
    "loadingOptions": "Yɛrehwehwɛ aduane ahorow ama wo...",
    "selectPreferences": "Yi Aduane A Wopɛ",
    "mealBuilder": "Aduane Siesie",
    "myFavorites": "M'aduane a Mepɛ Paa",
    "myFavoriteMeals": "M'aduane a Mepɛ Paa",
    "noFavoritesYet": "Wunnya nnyii aduane a wopɛ paa!",
    "price": "Boɔ",
    "delivery": "Aduane-Brɛ",
    "deliveryFee": "Ɔkwan So Ka",
    "distance": "Kwan Tenten",
    "subtotal": "Sika a Ɛka Ho",
    "total": "Ne Nyinaa",
    "orderNumber": "Nɔma a Wɔde Tɔe",
    "vendor": "Oduanetonni",
    "totalAmount": "Sika Nyinaa",
    "estimatedDelivery": "Bere a Yɛtwɛn Sɛ Ɛbɛba",
    "whyThisMeal": "Adɛn nti na aduane yi ye",
    "selectThisMeal": "Yi Aduane Yi",
    "swapMeal": "Sesā Aduane",
    "orderThisMeal": "Tɔ Aduane Yi",
    "notAvailableNearYou": "Ɛnni baabi a wowɔ yi",
    "tryAdjustingPrefs": "Sesa w'aduane fɛm mpanimfoɔ sɛnea ɛbɛyɛ a wubuhu aduane afoforɔ",
    "myMealPlanSummary": "M'aduane Nhyehyɛe Ho Nsem",
    "saveCompletePlan": "Kora Nhyehyɛe No Nyinaa So",
    "yourFoodPreferences": "Aduane A Wopɛ",
    "editPreferences": "Sesa W'aduane Fɛm Mpanimfoɔ",
    "healthyMealDelivery": "Aduane Pa Brɛbea",
    "enableDelivery": "Ma Kwan ma Wɔmfa Mmra",
    "enterZipCode": "Hyɛ Wo Postcode / ZIP Sɛnea Ɛbɛyɛ a Wubuhu Aduane a Ɛwɔ Wo Mpɔtam",
    "enterPostcode": "Hyɛ Wo Postcode / ZIP Code",
    "postcodePlaceholder": "sɛ ebi ne, MK10 9XX anaa 10001",
    "postcodePartialHint": "Yɛsrɛ wo, hyɛ wo postcode nyinaa sɛnea ɛbɛyɛ a yɛbɛhunu nneɛma a ɛbɛn wo paa.",
    "noLocalPartnersFallback": "Yɛnyaa aduanetonfoɔ biara wɔ ha. Hwɛ nneɛma pa a yɛakyerɛw wɔ ha yi mmom.",
    "noLivePartnersFallback": "HealthLoop aduanetonfoɔ biara nni wo mpɔtam hɔ seesei.",
    "culturalNutritionTitle": "Mpɔtam Aduane Pa Hwehwɛbea",
    "culturalNutritionSubtitle": "Akwankyerɛ foforɔ a ɛfa nkwa pa ho — ɛne yɛn ammammerɛ hyia, ɛma nimdeɛ, na ɛfa baabi a wowɔ ho.",
    "viewIngredientGuidance": "Hwɛ Akwankyerɛ",
    "popularWellnessTitle": "Aduane Pa a Ɛwɔ Wo Mpɔtam",
    "popularWellnessIntro": "Aduane mu nneɛma a ɛne yɛn ammammerɛ hyia na ɛma ahoɔden a nkurɔfoɔ taa hwehwɛ wɔ wo mpɔtam.",
    "subsectionPopularFoodsTitle": "Da biara da Nkwa Pa Aduane",
    "subsectionCulturalIngredientsTitle": "Aduane mu Nneɛma Ho Nyansafuɔ Kyerɛ",
    "subsectionHealthySwapsTitle": "Aduane a Wubumi de Asesā",
    "subsectionLocalEnvironmentTitle": "Mpɔtam Nkwa Pa Tebea",
    "subsectionLocalEnvironmentIntro": "Mmeae a nkurɔfoɔ a wɔwɔ wo mpɔtam taa nnya aduane pa a ɛne yɛn ammammerɛ hyia.",
    "findLocalTitle": "Mpɔtam Aduane Pa",
    "findLocalSubtitle": "Hunu aduanetonfoɔ, sotɔɔ, ne nneɛma pa a ɛwɔ wo mpɔtam.",
    "findOptions": "Hwehwɛ Bio",
    "searching": "Yɛrehwehwɛ…",
    "nearbyVendorsFound": "Yɛanya mmeae {{count}} a wɔton aduane pa wɔ wo mpɔtam",
    "orderHintEnabled": "Miia \"Tɔ Aduane Yi\" wɔ aduane krataa biara ase na hu ne boɔ.",
    "orderHintDisabled": "Ma kwan wɔ \"Ma Kwan ma Wɔmfa Mmra\" wɔ atifi hɔ na wubumi atɔ ebi tɛɛ.",
    "localIngredientTitle": "Mpɔtam Aduane mu Nneɛma",
    "localIngredientIntro": "Aduane atitiriw a ɛne yɛn ammammerɛ hyia ne baabi a wubumi anya ebi.",
    "lookFor": "Hwehwɛ",
    "noVendorsFallback": "Aduanetonfoɔ a yɛagye wɔn atom nnya nni ha — nanso wubumi de akwankyerɛ a ɛwɔ atifi hɔ no akɔtɔ nneɛma wɔ gua anaa sotɔɔ biara mu.",
    "showingMealsFrom": "Yɛrekyerɛ aduane a ɛfiri",
    "sectionSnapshot": "Da biara Aduane Ho Mfonini",
    "sectionSnapshotSubtitle": "Nsuonom, ahoɔden ka, ne aduane nhyehyɛe ho nsɛm tiawa ma nnɛ.",
    "snapshotHydration": "Nsuonom",
    "snapshotHydrationHint": "Bɔ mmɔden nnom nsuo kuruwa 6–8 nnɛ.",
    "snapshotCalories": "Ahoɔden Ka (Calories)",
    "snapshotCaloriesHint": "Ɛrenkyɛ yɛbɛfi ase akyerɛ.",
    "snapshotBalance": "Aduane Nhyehyɛe",
    "mealsLogged": "aduane a wɔayi",
    "snapshotTip": "Nkwa Pa Afutuo",
    "snapshotTipHint": "Fa nneɛma te sɛ nhabannuru (vegetable) biako ka w'aduane a ɛdi hɔ no ho.",
    "sectionRecommendations": "Nyansafuɔ Nyansahyɛ",
    "sectionRecommendationsSubtitle": "Aduane mu nneɛma ho akwankyerɛ ne sesā ho nsɛm a ɛne yɛn ammammerɛ hyia.",
    "sectionGoals": "Aduane Ho Botae",
    "sectionGoalsSubtitle": "Di nsɛm a ɛhia wo no akyi.",
    "goalWeight": "Mu Duru Ho Mmoa",
    "goalWeightDesc": "Aduane a ɛbɛma wo mu duru atena faako a ɛsɛ.",
    "goalEnergy": "Ahoɔden Mmoa",
    "goalEnergyDesc": "Aduane a ɛbɛma wo ahoɔden atena hɔ bere tenten.",
    "goalImmunity": "Yadeɛ Ko Mmoa",
    "goalImmunityDesc": "Aduane a ɛhyɛ nipadua no den na ɛko tia yadeɛ.",
    "goalFamily": "Abusua Aduane",
    "goalFamilyDesc": "Aduane a ɛfata mmofra ne mmaa a wɔemem.",
    "sectionGuidance": "Aduane Ho Akwankyerɛ",
    "sectionGuidanceSubtitle": "Anɔpa, awia, ne anwummere aduane ho adwene a wubumi asesā.",
    "futureNutritionTitle": "Daakye Aduane Mmoa",
    "futureNutritionBody": "Nkwa pa aduane nhyehyɛe, aduanetonfoɔ mmoa, ne abusua aduane ho nsem bɛba HealthLoop so daakye.",
    "comingSoon": "Ɛreba Seesei Ara",
    "coverageLocalStores": "Mpɔtam aduane sotɔɔ",
    "coverageLocalFarms": "Mpɔtam mfuw",
    "coverageCertifiedVendors": "Aduanetonfoɔ a wɔagye wɔn atom",
    "coverageFreshProduce": "Aduane foforɔ",
    "medWellnessFutureTitle": "Aduro ne Nkwa Pa Mmoa",
    "medWellnessFutureDesc": "Ɛde w'aduane nhyehyɛe ne aduro ho akwankyerɛ bɔ mu. Wubumi anya eyi wɔ Mmoa & Mmoa fa no ase.",
    "pharmacyAssistFutureTitle": "Aduruyɛbea Mmoa",
    "pharmacyAssistFutureDesc": "Hunu aduruyɛbea a ɛbɛn wo ne nkaebɔ a ɛfa aduro ho wɔ w'aduane ho. Wubumi anya eyi wɔ Mmoa & Mmoa fa no ase.",
    "savePreferences": "Kora Nneɛma a Wopɛ So",
    "quickAccessSavedMeals": "Kwan tiawa a wubumi de ahu aduane a woakora so",
    "saveMealsFromBuilder": "Kora aduane so firi Aduane Siesie fa no mu",
    "chooseVendor": "Yi oduanetonni a wopɛ sɛ wotɔ aduane yi firi ne hɔ",
    "yourCart": "Wo Kɛntɛn",
    "addMealsToStart": "Fa aduane ka ho firi nneɛma a ɛwɔ ase ha no mu na hyɛ aseɛ",
    "orderPlacedDesc": "W'aduane tɔ no akɔ yie",
    "continueShopping": "Toa So Tɔ Nneɛma",
    "trackOrder": "Di W'aduane Akyi"
  },
  "messages": {
    "success": "Eyɛ!",
    "error": "Mfomsoɔ bi aba",
    "saved": "Yɛakora so yie",
    "updated": "Yɛayɛ no foforɔ yie",
    "deleted": "Yɛayi afiri hɔ yie",
    "confirmDelete": "Wopɛ paa sɛ wuyi eyi afiri hɔ?",
    "networkError": "Intanɛt mfomsoɔ. Yɛsrɛ wo, bɔ mmɔden bio.",
    "somethingWrong": "Biribi ankɔ yie",
    "failedToLoad": "Yɛntumi amue kwan no",
    "offlineMode": "Intanɛt nni hɔ - nneɛma kakra na ɛrekyerɛ",
    "locationDenied": "Wunnyaa kwan anhwehwɛ baabi a wowɔ. Hwɛ wo browser nhyehyɛe mu na ma kwan.",
    "locationUnavailable": "Yɛntumi nnya baabi a wowɔ ho asɛm",
    "locationTimeout": "Bere a yɛde hwehwɛɛ baabi a wowɔ no aso. Yɛsrɛ wo, bɔ mmɔden bio.",
    "locationError": "Yɛntumi nhunu baabi a wowɔ",
    "locationGranted": "Woama kwan sɛ yɛnhunu baabi a wowɔ! Yɛrekyerɛ wo nneɛma a ɛbɛn wo",
    "locationNotSupported": "Wo browser yi mma kwan mma yɛnhunu baabi a wowɔ",
    "requestingLocation": "Yɛresrɛ kwan sɛ yɛnhunu baabi a wowɔ..."
  },
  "trust": {
    "medicalDisclaimer": "Kɔkɔbɔ",
    "privacySecure": "Wo ho asɛm yɛ kokoamsɛm na ɛbɛn",
    "dataEncrypted": "Nneɛma a woakyerɛw nyinaa yɛ kokoamsɛm",
    "notMedicalAdvice": "Ɛnyɛ aduruyɛ afutuo",
    "consultProvider": "Bere biara ne wo dɔkota nni nkitaho",
    "evidenceBased": "Akwankyerɛ a egyina nyansahu so",
    "generalEducation": "Nkwa pa ho nkyerɛkyerɛ",
    "preventiveGuidance": "Akwankyerɛ a ɛsi yadeɛ kwan",
    "lifestyleSupport": "Ɛfa nimdeɛ ne asetena mu mmoa ho",
    "lastUpdated": "Bere a yɛayɛ no foforɔ",
    "expertReviewed": "Animdefoɔ ahwɛ mu",
    "aiGenerated": "AI na ɛde adwene yi bae",
    "disclaimerShort": "HealthLoop de nkwa pa ho nkyerɛkyerɛ ma na ɛnyɛ dɔkota afutuo na ɛsi ananmu.",
    "disclaimerFull": "HealthLoop boa nkwa pa ne yadeɛ ho nkaesɛm. Yɛde nkwa pa ho nkyerɛkyerɛ, suban pa akyidi, ne nkwa pa ho nimdeɛ ma. Eyi nsi dɔkota ayaresa ananmu. Bere biara ne dɔkota a ɔwɔ tumi krataa nni nkitaho ma wonya wellness guidance, nhwehwɛmu, anaa ayaresa.",
    "trustBanner": {
      "title": "HealthLoop wɔ ha sɛ ɔbɛboa wo nkwa pa kwan so",
      "description": "Yɛde nkwa pa ho nkyerɛkyerɛ ne akwankyerɛ a ɛsi yadeɛ kwan ma a egyina baabi a yɛde yɛn ho to so. Eyi nsi dɔkota afutuo ananmu. Bere biara ne dɔkota a ɔwɔ tumi krataa nni nkitaho ansa na woasi nkwa pa ho gyinae."
    }
  },
  "health": {
    "preventiveHealth": "Yadeɛ-Si-Kwan Akyidi",
    "educationHub": "Nkyerɛkyerɛ Bea",
    "engagementWidget": "Mmoa Afiri",
    "wellnessCheckIn": "Nkwa Pa Nhwehwɛmu",
    "todaysMetrics": "Nnɛ Nkwa Pa Nsɛm",
    "bloodPressure": "Mogya Mmoaborɔ",
    "heartRate": "Akoma Bɔ",
    "weight": "Mu Duru",
    "sleep": "Nna",
    "waterIntake": "Nsuonom",
    "exercise": "Apɔmuden Apkan",
    "logMetric": "Kyerɛw Nsɛm No",
    "viewHistory": "Hwɛ Tete Nsɛm"
  },
  "aiInsights": {
    "title": "AI Nkwa Pa Ho Nimdeɛ",
    "comingSoon": "Wo nimdeɛ rekɔ so",
    "comingSoonDesc": "Yɛ da biara nhwehwɛmu biako anaa mmienu na yɛbɛma wo nkwa pa ho nimdeɛ a ɛfa wo ho paa wɔ ha.",
    "learnMore": "Hu pii",
    "evidenceSources": {
      "WHO": "Egyina WHO akwankyerɛ so",
      "NHS": "Ɛne NHS afutuo hyia",
      "CDC": "Egyina CDC akwankyerɛ so",
      "RESEARCH": "Egyina nhwehwɛmu so",
      "CLINICAL": "Egyina ayaresa nhwehwɛmu so"
    }
  },
  "dailyInsight": {
    "title": "Da biara Nkwa Pa Nimdeɛ",
    "gettingStarted": "Hyɛ Aseɛ",
    "focus": "Fa w'adwene si so",
    "quickInsight": "Nimdeɛ Tiawa",
    "simpleExplanation": "Nkyerɛkyerɛmu a ɛnyɛ den",
    "realLifeImpact": "Mfasoɔ wɔ asetena mu",
    "yourActionStep": "Nea ɛsɛ sɛ woyɛ",
    "basedOnYour": "Egyina wo",
    "personalizedFor": "Yɛayɛ no ama wo a egyina wo nkwa pa ho nsɛm so",
    "getNewInsight": "Nya nimdeɛ foforɔ",
    "newInsightLoaded": "Nimdeɛ foforɔ aba! 💡",
    "failedToRefresh": "Yɛntumi anya nimdeɛ foforɔ",
    "priority": {
      "high": "Ma Yɛnfa Yɛn Adwene Si Ha",
      "medium": "Ɛhia Sɛ Wohu"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "Nkaebɔ biara nni hɔ seesei",
    "noAlertsDesc": "Woadi suban pa akyi. Toa so saa!",
    "whatYouCanDo": "Nea wubumi ayɛ:",
    "viewMealSuggestions": "Hwɛ Aduane Nyansahyɛ a Ɛfa Wo Ho"
  },
  "engagement": {
    "currentStreak": "Streak a Wowɔ So Seesei",
    "bestStreak": "Streak a Eye Paa",
    "thisWeek": "Dapɛn Yi",
    "exerciseDays": "Apɔmuden Nda",
    "hydrationDays": "Nsuonom Nda",
    "healthMetricsLogged": "Nkwa Pa Nsɛm a Woakyerɛw",
    "weeklyGoalsProgress": "Dapɛn Botae Nkɔsoɔ",
    "completed": "awie",
    "days": "nda",
    "keepGoing": "Toa so!",
    "personalRecord": "Wo ankasa kyerɛw foforɔ!",
    "goalMet": "Woadu botae no ho!"
  },
  "reminders": {
    "title": "Nkwa Pa Nkaebɔ",
    "subtitle": "Tena kwan so ne nkaebɔ a ɛfa wo ho",
    "breakfast": "Anɔpaduane Nkaebɔ",
    "lunch": "Awiaduan Nkaebɔ",
    "dinner": "Anwummereduane Nkaebɔ",
    "water": "Nsuonom",
    "movement": "Kekā Wo Ho",
    "sleep": "Nna Nkaebɔ",
    "wellness": "Nkwa Pa Nhwehwɛmu",
    "healthLogging": "Nkwa Pa Nsɛm Kyerɛw",
    "annualCheckup": "Afe Biara Nhwehwɛmu",
    "enable": "Ma Kwan",
    "disable": "Si Kwan",
    "customize": "Siesie Bere",
    "stayConsistent": "Di Kwan So Bere Biara ne Nkaebɔ",
    "setupFriendly": "Siesie nkaebɔ a ɛyɛ dɛ sɛnea ɛbɛboa wo ma woanya suban pa.",
    "customizeWhen": "Wubumi asiesie bere ne mpɛn dodow a wopɛ sɛ wonya nkaebɔ biara.",
    "supportive": "Mma wo ho nnwiri wo - yɛbɛma no ayɛ dɛ na anyɛ hwee! 💚",
    "noPreferences": "Yɛnyaa Nkaebɔ Nhyehyɛe Biara",
    "noPreferencesDesc": "Yɛntumi amue wo nkaebɔ nhyehyɛe no. Ebia ɛyɛ wo bere a ɛdi kan, anaa mfomsoɔ bi bae bere a yɛremue no.",
    "retryLoading": "Bɔ Mmɔden Bio",
    "saveSettings": "Kora Nhyehyɛe So",
    "saving": "Ɛrekora so..."
  },
  "empty": {
    "startJourney": "Hyɛ Wo Nkwa Pa Kwan No Ase",
    "startJourneyDesc": "Hyɛ wo nkwa pa kwan ase nnɛ! Kyerɛ sɛnea wote nka sɛnea ɛbɛyɛ a wubenya nimdeɛ na woadi wo nkwa pa akyi.",
    "completeFirstCheckIn": "Yɛ Nhwehwɛmu a Ɛdi Kan",
    "stayOnTrack": "Tena Kwan So",
    "stayOnTrackDesc": "Di wo nhyehyɛe akyi bere biara 💊 Fa w'aduro ka ho na nya nkaebɔ ne mmoa.",
    "addFirstMedication": "Fa Aduro a Ɛdi Kan Ka Ho",
    "learnMedicationSafety": "Sua Aduro Ho Ahobammɔ",
    "buildMealLibrary": "Siesie W'aduane Bea",
    "buildMealLibraryDesc": "Wunnya aduane biara a wopɛ paa. Kora aduane a wopɛ so sɛnea ɛbɛyɛ a wubumi anya no ntɛm.",
    "exploreMealOptions": "Hwehwɛ Aduane Afoforɔ",
    "insightsAwait": "Wo Nimdeɛ Retwɛn Wo",
    "insightsAwaitDesc": "Yɛ da biara nhwehwɛmu na di wo nkwa pa akyi sɛnea ɛbɛyɛ a wubenya nimdeɛ foforɔ.",
    "startDailyCheckIn": "Hyɛ Da biara Nhwehwɛmu Ase",
    "learnAboutInsights": "Sua Nimdeɛ Ho Asɛm",
    "buildingStory": "Wo Nkwa Pa Abakɔsɛm",
    "buildingStoryDesc": "Tete nsɛm biara nni hɔ seesei. Wo nkwa pa nsɛm bɛpue wɔ ha sɛ woyɛ da biara nhwehwɛmu a.",
    "completeCheckIn": "Yɛ Nhwehwɛmu No",
    "tipComplete7Days": "Afutuo: Yɛ nhwehwɛmu nda 7 sɛnea ɛbɛyɛ a wubuhu nkɔsoɔ pa.",
    "startTrackingHabits": "Hyɛ Suban Pa Akyidi Ase",
    "startTrackingHabitsDesc": "Wunnnya mfaa suban biara nnyɛɛ hɔ. Nneyɛe nketewa na ɛsesa nkwa pa. Hyɛ wo suban pa nhyehyɛe ase nnɛ.",
    "trackFirstHabit": "Di Suban a Ɛdi Kan Akyi",
    "getMoving": "Kekā Wo Ho",
    "getMovingDesc": "Wunnya nkyerɛwee apɔmuden biara. Simma 10 mpo a wode bɛkekā wo ho bɛma w'ani agye na woanya ahoɔden.",
    "logActivity": "Kyerɛw Dwumadie No",
    "allCaughtUp": "Nneɛma Nyinaa Atwa So!",
    "allCaughtUpDesc": "Wunni nkaebɔ foforɔ biara. Sane ba akyire yi bɛhwɛ nkaebɔ foforɔ.",
    "noResultsFound": "Yɛnyaa Biribiara",
    "noResultsFoundDesc": "Yɛnyaa biribiara mmaa \"{query}\". Bɔ mmɔden sesa w'ahwehwɛdeɛ no."
  },
  "footer": {
    "tagline": "Wo Boafoɔ a ɔde AI bɛhwɛ Wo Apɔmuden so",
    "builtWith": "Yɛde ɔdɔ na ɛyɛeɛ sɛnea ɛbɛboa wo apɔmuden akwantuo no",
    "allRightsReserved": "Yɛkora tumi nyinaa so.",
    "about": "Ho Asɛm",
    "privacy": "Ankonamyɛ",
    "terms": "Mmara",
    "contact": "Yɛne yɛn nni nkitaho",
    "helpCenter": "Mmoa Beaeɛ"
  },
  "modals": {
    "feedback": {
      "title": "Kyɛ Wo Nyansafoɔ Kyerɛ",
      "subtitle": "Boa yɛn ma HealthLoop nyɛ papa kɛse",
      "whatWorking": "Deɛn na ɛreyɛ adwuma yie?",
      "whatImprove": "Deɛn na yɛbɛtumi ayɛ no yie asen deɛ ɛwɔ hɔ yi?",
      "placeholder": "Kyɛ w'adwene...",
      "thankYou": "Yɛda wo ase wɔ wo nyansafoɔ kyerɛ no ho!",
      "submitted": "Wo nyansafoɔ kyerɛ no bɛboa ama HealthLoop atu mpɔn."
    },
    "reportProblem": {
      "title": "Bɔ Amanneɛ fa Ɔhaw bi Ho",
      "subtitle": "Boa yɛn ma yɛsiesie mfomsoɔ na yɛyɛ app yi yie",
      "describe": "Kyerɛkyerɛ ɔhaw no mu",
      "placeholder": "Deɛn na ɛsiiɛ? Yɛsrɛ wo, kyerɛkyerɛ mu pɛpɛɛpɛ...",
      "optional": "Sɛ wopɛ: Akwan a wofaa so huu ɔhaw no",
      "stepsPlaceholder": "1. Mekɔɔ...\n2. Afei meyɛɛ...",
      "thankYou": "Yɛda wo ase sɛ woabɔ amanneɛ!",
      "submitted": "Yɛbɛhwɛ asɛm yi mu ntɛm pa ara."
    },
    "mealPreferences": {
      "title": "Hyehyɛ Wo Nnuane",
      "subtitle": "Kyerɛ yɛn nnuane ko a wopɛ",
      "cuisines": "Aduane a wopɛ",
      "selectCuisines": "Yi deɛ ɛfata wo nyinaa",
      "dietary": "Aduane ho nhyehyɛe",
      "selectDietary": "Yi aduane a wo dwumadie hia",
      "allergies": "Aduane a mma wo kwan anaa ɛnyɛ mma wo",
      "allergiesPlaceholder": "Ebi ne, Nkatie, Po mu nam, Aduane a protein (gluten) wom",
      "save": "Kora Nhyehyɛe no so",
      "saving": "Ɛrekora so..."
    },
    "upgrade": {
      "title": "Kɔ Premium",
      "subtitle": "Nya kwan kɔ nneɛma nyinaa mu",
      "features": "Nneɛma soronko a ɛwɔ Premium mu",
      "getStarted": "Fi ase seesei",
      "learnMore": "Suasua pii"
    }
  },
  "login": {
    "title": "Wo Apɔmuden ne Akwahosan Dwumadie Beaeɛ",
    "subtitle": "Di wo nkɔsoɔ akyi, sua adeɛ, na yɛ ho adwuma ansa na ɔhaw aba. Yɛyɛɛ yei mma apɔmuden bɔne kwan, adesua, ne akwahosan.",
    "email": "E-mail",
    "password": "Password",
    "signIn": "Wura mu",
    "signingIn": "Ɛrewura mu...",
    "forgotPassword": "Wo werɛ afi wo Password?",
    "noAccount": "Wunni account?",
    "createAccount": "Yɛ bi foforɔ",
    "biometricLogin": "Fa Biometrics wura mu",
    "biometricHelper": "Fa wo nsa nkyerɛwee, Face ID, anaa Windows Hello",
    "authenticating": "Yɛrepɛ mu kwan...",
    "vendorPartner": "Woyɛ yɛn dwumadie hyehyɛfoɔ bi?",
    "vendorLogin": "Vendor Login",
    "emailRequired": "Yɛsrɛ wo, di kan hyehyɛ wo e-mail",
    "biometricSuccess": "Woatumi de biometrics awura mu! 🎉",
    "noPasskeys": "Wunni biometric nhyehyɛe biara. Yɛsrɛ wo, fa password di kan wura mu.",
    "biometricCancelled": "Wogyae biometric dwumadie no mu",
    "biometricFailed": "Biometric dwumadie no antumi anyɛ yie. Yɛsrɛ wo, fa password wura mu."
  },
  "register": {
    "title": "Wura HealthLoop mu",
    "subtitle": "Fi wo apɔmuden akwantuo no ase nnɛ",
    "fullName": "Din nyinaa",
    "email": "E-mail",
    "password": "Password",
    "confirmPassword": "Si Password no pi",
    "createAccount": "Yɛ Account foforɔ",
    "haveAccount": "Woahyehyɛ account dedaw?",
    "signIn": "Wura mu",
    "creating": "Yɛreyɛ account foforɔ...",
    "passwordTooShort": "Password no nkyerɛwee ɛnsɛ sɛ ɛsua sene 8",
    "setupBiometric": "Hyehyɛ Biometric Login",
    "setupBiometricDesc": "Fa wo nsa nkyerɛwee, Face ID, anaa Windows Hello na woatumi awura mu ntɛm na w'asɛm asie yie",
    "setupNow": "Hyehyɛ Biometric Login seesei",
    "skipForNow": "Twa mu seesei",
    "settingUp": "Ɛrehyehyɛ...",
    "benefit1": "Password biara nni hɔ a ɛsɛ sɛ wokora so",
    "benefit2": "W'asɛm bɛsie yie kɛse ne biometric nhwehwɛmu",
    "benefit3": "Fa w'anim anaa wo nsa ka kɛkɛ na wura mu",
    "biometricPrivacy": "Wo biometric nkyerɛwee no mfiri wo mfiri no so mma baabiara",
    "biometricSuccess": "Biometric login nhyehyɛe no yɛɛ yie! 🎉",
    "biometricFailed": "Biometric nhyehyɛe no antumi anyɛ yie. Wobɛtumi ayɛ no akyire wɔ settings mu.",
    "biometricSetupLater": "Wobɛtumi ahyehyɛ biometric login akyire wɔ wo profile settings mu"
  },
  "womensHealthPage": {
    "title": "Mmaa Apɔmuden Hwɛfoɔ",
    "subtitle": "Di wo bosome mu nkyebae, wo honam mu nsakraeɛ, ne w'akwahosan akyi",
    "cycleOverview": "Bosome mu nsakraeɛ ho mfonini",
    "currentPhase": "Baabi a wowɔ seesei",
    "nextPeriod": "Bosome a ɛreba no da",
    "logPeriod": "Kyerɛw w'asɛm fa wo bosome ho",
    "logSymptoms": "Kyerɛw nsakraeɛ a wuhu wɔ wo honam mu",
    "insights": "Bosome mu nsakraeɛ ho nkyerɛkyerɛmu",
    "tips": "Afutuo a ɛfa baabi a wowɔ ho",
    "history": "Bosome a atwam ho kyerɛwtohɔ",
    "noData": "Nkyerɛwtohɔ biara mmaa ɛfa wo bosome ho",
    "noDataDesc": "Fi ase kyerɛw w'asɛm fa wo bosome ho na woanya akwankyerɛ ne nyansafoɔ kyerɛ.",
    "startTracking": "Fi ase kyerɛw asɛm no"
  },
  "notifications": {
    "title": "Nkaebɔ",
    "markAllRead": "Hyɛ ne nyinaa sɛ woakenkan",
    "noNotifications": "Nkaebɔ foforɔ biara nni hɔ",
    "viewAll": "Hwɛ ne nyinaa"
  },
  "familyHealth": {
    "title": "Abusua ne Mmɔfra Apɔmuden",
    "subtitle": "Akwankyerɛ a ɛfa abusua nyinaa apɔmuden ho",
    "tabImmunizations": "Ntasuoyie (Vaccines)",
    "tabEducation": "Adesua",
    "tabReminders": "Nkaebɔ",
    "tabPlanner": "Abusua Nhyehyɛe",
    "immunizations": {
      "title": "Ntasuoyie (Vaccine) Ho Nimdeɛ",
      "subtitle": "Hu ntasuoyie a ɛhia sɛ wonya",
      "recommendedSchedule": "Nhyehyɛe a ɛfata",
      "byAge": "Sɛnea mfeɛ teɛ",
      "infants": "Akokoaa (Abosome 0-12)",
      "toddlers": "Mmɔfra (Mfeɛ 1-3)",
      "preschool": "Mmofrayɛ mu (Mfeɛ 4-6)",
      "schoolAge": "Sukuu mfeɛ (Mfeɛ 7-12)",
      "teens": "Mmabun (Mfeɛ 13-18)",
      "adults": "Mpanyinfɔ",
      "learnMore": "Suasua pii",
      "consultDoctor": "Bere biara ne w'ayaresabea hwɛfoɔ nni nkitaho fa ntasuoyie nhyehyɛe a ɛfata wo ho",
      "upcomingReminders": "Ntasuoyie nkaebɔ a ɛreba",
      "noReminders": "Nkaebɔ biara nni hɔ seesei",
      "addReminder": "Hyehyɛ nkaebɔ foforɔ mma vaccine",
      "reminderFor": "Nkaebɔ ma",
      "dueDate": "Da a ɛsɛ sɛ woyɛ",
      "notes": "Nsɛm foforɔ",
      "markComplete": "Hyɛ no sɛ woawie"
    },
    "education": {
      "title": "Abusua Apɔmuden Adesua",
      "subtitle": "Apɔmuden ho nsɛm a ɛfa nea nyansahu kyerɛ ho",
      "categories": "Nkyekyɛmu",
      "infant": "Akokoaa Hwɛ",
      "child": "Abofra Nyini",
      "nutrition": "Aduane ne Nyini",
      "safety": "Ahobammɔ ne Akwanhyia ho kwan bɔ",
      "mental": "Adwene mu Akwahosan",
      "hygiene": "Ahotie ne Suban pa",
      "searchPlaceholder": "Hwehwɛ apɔmuden asɛm bi...",
      "popularTopics": "Nsɛm a nnipa pii pɛ",
      "readMore": "Kenkan pii",
      "readTime": "simma a wobɛkenkan"
    },
    "reminders": {
      "title": "Abusua Apɔmuden Nkaebɔ",
      "subtitle": "Boa abusua no ma wɔnni wɔn apɔmuden nhyehyɛe so pɛpɛɛpɛ",
      "createReminder": "Yɛ Nkaebɔ",
      "familyMember": "Abusua mu nipa",
      "reminderType": "Nkaebɔ ko",
      "frequency": "Mpɛn dodoɔ",
      "activeReminders": "Nkaebɔ a ɛwɔ hɔ seesei",
      "upcomingThisWeek": "Deɛ ɛreba saa nnawɔtwe yi",
      "noActiveReminders": "Nkaebɔ biara nni hɔ seesei",
      "types": {
        "checkup": "Apɔmuden Nhwehwɛmu",
        "dental": "Ɛse ho ayaresabea",
        "vision": "Aniwa ho nhwehwɛmu",
        "vaccine": "Ntasuoyie (Vaccination)",
        "medication": "Aduro nom",
        "custom": "Nhyehyɛe soronko"
      }
    },
    "planner": {
      "title": "Abusua Apɔmuden Nhyehyɛfoɔ",
      "subtitle": "Hyehyɛ abusua no nyinaa apɔmuden ho asɛm",
      "addMember": "De abusua mu nipa foforɔ ka ho",
      "memberName": "Obi no din",
      "relationship": "Abusuabɔ",
      "dateOfBirth": "Awo da",
      "viewCalendar": "Hwɛ kalenda no",
      "upcomingCare": "Apɔmuden nhyehyɛe a ɛreba",
      "nothingScheduled": "Nhyehyɛe biara nni hɔ seesei",
      "scheduleCheckup": "Hyehyɛ nhwehwɛmu da",
      "relationships": {
        "child": "Abofra",
        "spouse": "Okunu/Ɔyere",
        "parent": "Ɔwofoɔ",
        "sibling": "Onua",
        "other": "Obi foforɔ"
      }
    },
    "content": {
      "infantCare": {
        "title": "Akokoaa Apɔmuden Hwɛ",
        "intro": "Apɔmuden ho suban pa a ɛhia ma wo ba no afe a ɛdi kan",
        "topics": [
          "Akokoaa nhwehwɛmu nhyehyɛe",
          "Abofra no nyini ho nkaebɔ",
          "Nna mu ahobammɔ",
          "Aduane ne nufu ma",
          "Ntasuoyie (Vaccine) nhyehyɛe"
        ]
      },
      "childDevelopment": {
        "title": "Abofra Nyini ne Nkɔsoɔ",
        "intro": "Twa nyini ne nkɔsoɔ pa ho mfonini",
        "topics": [
          "Honam mu nkɔsoɔ ho nkaebɔ",
          "Nnipa ne nkitahodie ne nkateɛ mu nkɔsoɔ",
          "Kasa mu nkɔsoɔ",
          "Adwene mu nkɔsoɔ",
          "Berɛ a ɛsɛ sɛ wo ne dɔkota kasa"
        ]
      },
      "nutrition": {
        "title": "Aduane ne Nyini Pa",
        "intro": "Aduane pa suban a wobɛhyɛ aseɛ mfitiaseɛ",
        "topics": [
          "Aduane a ɛfata mfeɛ biara",
          "Nnuane nketewa pa ho nyansafoɔ kyerɛ",
          "Sɛnea wobɛhwɛ mmɔfra a wɔn aduane ho yɛ den",
          "Aduane ho ahotie",
          "Nsuo nom ho akwankyerɛ"
        ]
      },
      "safety": {
        "title": "Ahobammɔ ne Akwanhyia ho Kwan bɔ",
        "intro": "Yɛ baabi a ɛbɔ abusua no ho ban",
        "topics": [
          "Efie mu ahobammɔ ho nkaebɔ",
          "Lorry mu ntenaseɛ ahobammɔ",
          "Nsuo ho ahobammɔ",
          "Aduro bɔne ho kwan bɔ",
          "Amanneɛhunu ho asiesie"
        ]
      }
    }
  }
};
